(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("angular-animate"), require("matchmedia-ng"), require("moment"), require("toastr"));
	else if(typeof define === 'function' && define.amd)
		define("infocertFeconClientBundle", ["_", "angular-animate", "matchmedia-ng", "moment", "toastr"], factory);
	else if(typeof exports === 'object')
		exports["infocertFeconClientBundle"] = factory(require("lodash"), require("angular-animate"), require("matchmedia-ng"), require("moment"), require("toastr"));
	else
		root["infocertFeconClientBundle"] = factory(root["_"], root["angular-animate"], root["matchmedia-ng"], root["moment"], root["toastr"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_78__, __WEBPACK_EXTERNAL_MODULE_79__, __WEBPACK_EXTERNAL_MODULE_80__, __WEBPACK_EXTERNAL_MODULE_81__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryParamGetter;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Restituisce il valore del query param globale (non inerente alla navigazione client-side)
* @param name nome del parametro
* @param caseInsensitive cerca il parametro nella forma case-insensitive (default: false)
*/
function queryParamGetter(name, caseInsensitive) {
  caseInsensitive = !!caseInsensitive;

  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

  var regexModifiers = '';
  if (caseInsensitive) {
    regexModifiers = regexModifiers + 'i';
  }
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', regexModifiers),
      results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

queryParamGetter.asBoolean = function asBoolean(name, caseInsensitive) {
  var val = _lodash2.default.trim(_lodash2.default.toLower(queryParamGetter(name, caseInsensitive)));
  return !!(val && val != '' && val != 'false' && val != '0' && val !== undefined);
};
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(82);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76), __webpack_require__(77)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(52);

var _utils2 = _interopRequireDefault(_utils);

var _utils3 = __webpack_require__(63);

var _utils4 = _interopRequireDefault(_utils3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.utils', [_utils2.default, _utils4.default]).name;
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _infocertJs = __webpack_require__(41);

var _infocertJs2 = _interopRequireDefault(_infocertJs);

var _infocertJs3 = __webpack_require__(75);

var _infocertJs4 = _interopRequireDefault(_infocertJs3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.fecon-client-bundle', [_infocertJs2.default, _infocertJs4.default]).name;

/*
import _queryParamGetter from './infocert.js.angular/utils/utils.services/queryparam.getter';
export const queryParamGetter = _queryParamGetter;
*/

module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(4);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _index2.default;
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Log Unobtrusive Extension v0.0.7
 *
 * Used within AngularJS to enhance functionality within the AngularJS $log service.
 *
 * @original-author  Thomas Burleson
 * @contributor Layton Whiteley
 * @contributor A confused individual <ferronrsmith@gmail.com>
 * @website http://www.theSolutionOptimist.com
 * (c) 2013 https://github.com/lwhiteley/AngularLogExtender
 * License: MIT
 *
 * Modifications made by @contributor Layton Whiteley:
 * - Modified to be a full stand-alone Angular Application for reuse
 * - Has global and feature level activation/disabling for $log
 * - Created and tested with AngularJS v.1.2.3
 */
angular.module("log.ex.uo", []).provider('logEx', ['$provide', function ($provide) {

    // Creates an injector function that can be used for retrieving services as well as for dependency injection
    var $injector = angular.injector(['ng']);

    // Used the $injector defined to retrieve the $filterProvider
    var $filter = $injector.get('$filter');

    /**
     * Used to enable logging globally
     * @type {boolean}
     */
    var enableGlobally = false;

    /**
     * Used to activate logPrefix overriding
     * @type {boolean}
     */
    var logPrefixOverride = false;

    /**
     * Used to force log-ex to use the default log prefix rules
     * @type {boolean}
     */
    var useDefaultPrefix = false;

    /**
     * Used to store custom log prefix rules
     * @type {null | Function}
     */
    var customLogPrefixFn = null;

    /**
     * current browser's user agent
     * @type {string}
     */
    var userAgent = navigator.userAgent;

    /**
     * default log methods available
     * @type {string[]}
     */
    var defaultLogMethods = ['log', 'info', 'warn', 'debug', 'error', 'getInstance'];

    /**
     * list of browsers that support colorify
     * @type {string[]}
     */
    var colorifySupportedBrowsers = ['chrome', 'firefox'];

    /**
     * flag to activate/deactivate default log method colors
     * @type {boolean}
     */
    var useDefaultColors = true;

    /**
     * default colours for each log method
     * @type {object}
     */
    var defaultLogMethodColors = {
        log: 'color: green;',
        info: 'color: blue',
        warn: 'color: #CC9933;',
        debug: 'color: brown;',
        error: 'color: red;'
    };

    /**
     * publicly allowed methods for the extended $log object.
     * this give the developer the option of using special features
     * such as setting a className and overriding log messages.
     * More Options to come.
     * @type {string[]}
     */
    var allowedMethods = defaultLogMethods;

    /**
     * Trims whitespace at the beginning and/or end of a string
     * @param {String} value - string to be trimmed
     * @returns {String} - returns an empty string if the value passed is not of type {String}
     */
    var trimString = function trimString(value) {
        if (itypeof(value) === 'string') return value.replace(/^\s*/, '').replace(/\s*$/, '');
        return "";
    };

    /**
     * The itypeof operator returns a string indicating the type of the unevaluated operand.
     * @param {*} val - object to be evaluated
     * @returns {String} -  returns a string with the type of the evaluated operand
     */
    var itypeof = function itypeof(val) {
        return Object.prototype.toString.call(val).replace(/(\[|object|\s|\])/g, "").toLowerCase();
    };

    /**
     * checks if a variable is of @type {boolean}
     * @param {boolean} value - flag to be evaluated
     * @returns {boolean} - returns true if evaluated object is a boolean
     */
    var isBoolean = function isBoolean(value) {
        return itypeof(value) === 'boolean';
    };

    /**
     * This method checks if a variable is of type {string}
     * and if the string is not an empty string
     * @param {string} value - string to be evaluated
     * @returns {*|Boolean|boolean} - returns true if string is not null or empty
     */
    var isValidString = function isValidString(value) {
        return itypeof(value) === 'string' && trimString(value) !== "";
    };

    /**
     * checks if @param1 is a substring of @param2
     * @param {string} sub - partial string that may be a sub string
     * @param {string} full - full string that may have the unevaluated substring
     * @returns {boolean} - returns true if a substring is found in the ful string
     */
    var isSubString = function isSubString(sub, full) {
        if (itypeof(sub) === 'string' && itypeof(full) === 'string') {
            if (full.toLowerCase().indexOf(sub.toLowerCase()) != -1) {
                return true;
            }
        }
        return false;
    };

    /**
     * The following method checks if useTemplate value is true and
     * if the log arguments array length is two
     * @param {boolean} useTemplate - flag that configures the usage of the template engine
     * @param {*[]} args - list of log arguments that should match pattern creating template strings
     * @returns {boolean} - returns true if log arguments match template pattern and useTemplate is set to true
     */
    var validateTemplateInputs = function validateTemplateInputs(useTemplate, args) {
        return isBoolean(useTemplate) && useTemplate && args.length == 2;
    };
    /**
     * supplant is a string templating engine that replaces patterns
     * in a string with values from a template object
     * @param {string} template - string with patterns to be replaced by values
     * @param {object} values - object with values to replace in template string
     * @param {RegExp=} pattern - custom regular expression of pattern to replace in template string
     * @returns {string} - returns formatted string if template and values match the required pattern
     */
    var supplant = function supplant(template, values, /*{RegExp=}*/pattern) {
        var criteria1 = itypeof(template) !== 'string' && itypeof(values) !== 'object';
        var criteria2 = itypeof(template) !== 'string' || itypeof(values) !== 'object';
        if (criteria1 || criteria2) {
            return Array.prototype.slice.call(arguments);
        }

        pattern = itypeof(pattern) === 'regexp' ? pattern : /\{([^\{\}]*)\}/g;

        return template.replace(pattern, function (a, b) {
            var p = b.split('.'),
                r = values;

            try {
                for (var s in p) {
                    r = r[p[s]];
                }
            } catch (e) {
                r = a;
            }

            return typeof r === 'string' || typeof r === 'number' ? r : a;
        });
    };

    /**
     * Checks if the current browser is a part of the supported browser list for adding colors
     * @returns {boolean} - returns true if the current browser supports colorify
     */
    var isColorifySupported = function isColorifySupported() {
        for (var i = 0; i < colorifySupportedBrowsers.length; i++) {
            if (isSubString(colorifySupportedBrowsers[i], userAgent)) {
                return true;
            }
        }
        return false;
    };

    /**
     * Stores flag to know if current browser is colorify supported
     * @type {boolean}
     */
    //TODO: Need to refactor this into a self-invoking function
    var isColorifySupportedBrowser = isColorifySupported();

    /**
     * The following method checks if the log arguments array length is one and the element is a string
     * @param {*[]} args - unevaluated log method arguments array that should contain only one element of type {string}
     * @returns {boolean} - returns true if args match the above criteria
     */
    var validateColorizeInputs = function validateColorizeInputs(args) {
        return args.length == 1 && itypeof(args[0]) === 'string';
    };

    /**
     * The following method does partial validation to ensure css string contains known keys
     * @param {string} css - css string to be evaluated
     * @returns {boolean} - returns true if string contains any supported keys
     */
    var containsColorCssKeys = function containsColorCssKeys(css) {
        return isSubString('color', css) || isSubString('background', css) || isSubString('border', css);
    };

    /**
     * The following method does partial validation to ensure css string is valid
     * @param {string} value - css string to be evaluated
     * @returns {boolean} - returns true if string has css format
     */
    var validateColorCssString = function validateColorCssString(value) {
        return itypeof(value) === 'string' && isSubString(':', value) && trimString(value).length > 6 && containsColorCssKeys(value);
    };

    /**
     * The following takes a string a returns an array as parameter if browser is supported
     * e.g. Expected outcome $log.log('%c Oh my heavens! ', 'background: #222; color: #bada55');
     * @param {string} message - string to be coloured
     * @param {string} colorCSS - css string to apply to message
     * @param {string} prefix - log prefix to be prepended to message
     * @returns {*[]} - returns colorify formatted array if all inputs are valid else returns array with the original message
     */
    var colorify = function colorify(message, colorCSS, prefix) {
        prefix = itypeof(prefix) === 'string' ? prefix : '';
        var canProcess = isColorifySupportedBrowser && validateColorCssString(colorCSS) && itypeof(message) === 'string';
        var output = canProcess ? '' + prefix + message : message;
        return canProcess ? ["%c" + output, colorCSS] : [output];
    };

    /**
     * This is the default method responsible for formatting the prefix of all extended $log messages pushed to the console
     * @see overrideLogPrefix to override the logPrefix
     * @param {string=} className - name of the component class ($controller, $service etc.)
     * @returns {string} - formatted string that will be prepended to log outputs
     */
    var defaultLogPrefixFn = function defaultLogPrefixFn( /**{String=}*/className) {
        var separator = " >> ",
            format = "MMM-dd-yyyy-h:mm:ssa",
            now = $filter('date')(new Date(), format);
        return "" + now + (itypeof(className) !== 'string' ? "" : "::" + className) + separator;
    };

    /**
     * This method is responsible for generating the prefix of all extended $log messages pushed to the console
     * @param {string=} className - name of the component class ($controller, $service etc.)
     * @returns {string} - formatted string that will be prepended to log outputs
     */
    var getLogPrefix = function getLogPrefix( /**{String=}*/className) {
        var prefix = '';
        if ((!isBoolean(useDefaultPrefix) || !useDefaultPrefix) && isBoolean(logPrefixOverride) && logPrefixOverride && angular.isFunction(customLogPrefixFn)) {
            prefix = customLogPrefixFn(className);
        } else {
            prefix = defaultLogPrefixFn(className);
        }
        return prefix;
    };
    // Register our $log decorator with AngularJS $provider
    //scroll down to the Configuration section to set the log settings
    $provide.decorator('$log', ["$delegate", function ($delegate) {
        /** 
         * Encapsulates functionality to extends $log and expose additional functionality
         **/
        var logEnhancerObj = function logEnhancerObj() {
            /**
             * processUseOverride returns true if the override flag is set.
             * this is used to activate the override functionality.
             * @param {boolean} override - unevaluated override flag
             * @returns {boolean} - returns true if override is a boolean
             */
            var processUseOverride = function processUseOverride(override) {
                return isBoolean(override);
            };

            /**
             * processOverride only takes true or false as valid input.
             * any other input will resolve as true.
             * this function is used to override the global flag for displaying logs
             * @param {boolean} override - unevaluated override flag
             * @returns {boolean} - returns true if override is not equal to false
             */
            var processOverride = function processOverride(override) {
                return override !== false;
            };

            /**
             * The following method checks if the global enabled flag and the override flag are set as type {boolean}
             * variables. If both are set it returns the value of the override flag to control $log outputs
             * @param {boolean} enabled - global flag that activates/deactivates logging
             * @param {boolean} override - flag that overrides the global enabled flag
             * @returns {boolean} - returns override if both params are booleans else returns {boolean=} false
             */
            var activateLogs = function activateLogs(enabled, override) {
                if (isBoolean(enabled) && isBoolean(override)) {
                    return override;
                }
                return false;
            };

            /**
             * The following method handles printing a message to the console indicating
             * if a $log instance is using an override.
             * If logging is disabled globally & an override of true is set,
             * then a message will be displayed for the specific $log instance
             * if logging is enabled globally & an override of false is set,
             * then a message will be displayed for the specific $log instance
             * @private for internal use only
             * @param _$log - $log instance
             * @param useOverride - flag that defines logic to regard using the override
             * @param _override - flag that overrides the global enabled flag
             * @param className - name of the component class ($controller, $service etc.)
             * @param enabled - global flag that activates/deactivates logging
             */
            var printOverrideLogs = function printOverrideLogs(_$log, useOverride, _override, className, enabled) {
                var instance = isValidString(className) ? className : "this instance";
                if (!enabled && useOverride && _override) {
                    _$log.log(getLogPrefix() + "[OVERRIDE] LOGGING ENABLED - $log enabled for " + instance);
                } else if (enabled && useOverride && !_override) {
                    _$log.log(getLogPrefix() + "[OVERRIDE] LOGGING DISABLED - $log disabled for " + instance);
                }
            };

            /**
             * Converts an array to a object literal
             * @private for internal use only
             * @param {*[]} arr - array to be transformed to object literal
             * @returns {{getInstance: (exports.packets.noop|*|container.noop|noop|)}}
             */
            var arrToObject = function arrToObject(arr) {
                var result = {};
                if (angular.isArray(arr)) {
                    result = {
                        getInstance: angular.noop
                    };
                    angular.forEach(arr, function (value) {
                        result[value] = angular.noop;
                    });
                }
                return result;
            };

            /**
             * General purpose method for building $log objects.
             * This method also provides the capability to specify the log methods to expose
             * @private for internal use only
             * @param {Object} oSrc - $log instance
             * @param {Array=} aMethods - list of $log methods
             * @param {Function=} func - function that defines rules for custom $log instance
             * @param {Array=} aParams - parameters to be used in prepareLogFn
             * @returns {Object} - returns a $log instance
             */
            var createLogObj = function createLogObj(oSrc, aMethods, /**{Function=}*/func, /**{*Array=}*/aParams) {
                var resultSet = {},
                    oMethods = arrToObject(aMethods);
                angular.forEach(defaultLogMethods, function (value) {
                    var res;
                    if (angular.isDefined(aParams)) {
                        var params = [];
                        angular.copy(aParams, params);
                        params.unshift(oSrc[value]);
                        if (isColorifySupportedBrowser && useDefaultColors) {
                            params[5] = validateColorCssString(params[5]) ? params[5] : defaultLogMethodColors[value];
                        }
                        res = func.apply(null, params);
                    } else {
                        res = oSrc[value];
                    }
                    resultSet[value] = angular.isUndefined(oMethods[value]) ? angular.noop : res;
                });
                return resultSet;
            };
            /**
             * Contains functionality for transforming the AngularJS $log
             * returns extended $log object
             * @param $log {Object} - original angular $log to be enhanced
             **/
            var enhanceLogger = function enhanceLogger($log) {

                /**
                 * Partial application to pre-capture a logger function
                 * @param {Function} logFn - $log method
                 * @param {*} className - name of the component class ($controller, $service etc.)
                 * @param {boolean} override - flag that overrides the global enable flag
                 * @param {boolean} useOverride - flag that defines logic to consider using the override
                 * @param {string} colorCss - css styles for coloring log methods
                 * @param {boolean} useTemplate - enables/disables the template engine
                 * @returns {Function} - returns function with specific rules for a log metod
                 */
                var prepareLogFn = function prepareLogFn(logFn, className, override, useOverride, useTemplate, colorCss) {
                    var enhancedLogFn = function enhancedLogFn() {
                        var activate = useOverride ? activateLogs(enabled, override) : enabled;
                        if (activate) {
                            var args = Array.prototype.slice.call(arguments);
                            var prefix = getLogPrefix(className);
                            if (validateTemplateInputs(useTemplate, args)) {
                                var data = supplant.apply(null, args);
                                data = itypeof(data) === 'string' ? [data] : data;
                                args = data;
                            }
                            if (itypeof(colorCss) === 'string' && validateColorizeInputs(args)) {
                                args = colorify(args[0], colorCss, prefix);
                            } else {
                                args.unshift(prefix);
                            }

                            if (logFn) logFn.apply(null, args);
                        }
                    };

                    // Only needed to support angular-mocks expectations
                    enhancedLogFn.logs = [];
                    return enhancedLogFn;
                };

                /**
                 * Capture the original $log functions; for use in enhancedLogFn()
                 * @type {*}
                 * @private
                 */
                var _$log = createLogObj($log, allowedMethods);

                /**
                 * Support to generate class-specific logger instance with/without className or override
                 * @param {*} className - Name of object in which $log.<function> calls is invoked.
                 * @param {boolean=} override - activates/deactivates component level logging
                 * @param {boolean=} useTemplate - enables/disables the template engine
                 * @param {String=} colorCss - css styles for coloring log methods
                 * @returns {*} $log instance - returns a custom log instance
                 */
                var getInstance = function getInstance( /*{*=}*/className, /*{boolean=}*/override, /*{boolean=}*/useTemplate, /*{String=}*/colorCss) {
                    if (isBoolean(className)) {
                        override = className;
                        className = null;
                    } else if (itypeof(className) === 'string') {
                        className = trimString(className);
                    } else {
                        className = null;
                    }
                    var useOverride = processUseOverride(override);
                    override = processOverride(override);
                    printOverrideLogs(_$log, useOverride, override, className, enabled);
                    return createLogObj(_$log, allowedMethods, prepareLogFn, [className, override, useOverride, useTemplate, colorCss]);
                };

                //declarations and functions , extensions
                /**
                 * Used to enable/disable logging
                 * @type {boolean}
                 */
                var enabled = false;

                /**
                 * Extends the $log object with the transformed native methods
                 * @param $log - $log instance
                 * @param {function} createLogObj -  defines transformation rules
                 **/
                angular.extend($log, createLogObj($log, allowedMethods, prepareLogFn, [null, false, false, false, null]));

                /**
                 * Extend the $log with the {@see getInstance} method
                 * @type {getInstance}
                 */
                $log.getInstance = getInstance;

                /**
                 * The following method enable/disable logging globally
                 * @param {boolean} flag - boolean flag specifying if log should be enabled/disabled
                 */
                $log.enableLog = function (flag) {
                    enabled = flag;
                };

                /**
                 * The following returns the status of the {@see enabled}
                 * @returns {boolean} - returns global enabled flag
                 */
                $log.logEnabled = function () {
                    return enabled;
                };
                return $log;
            };
            //---------------------------------------//

            /**
             * The following function exposes the $decorated logger to allow the defaults to be overridden
             * @param $log - $log instance
             * @returns {*} - returns $log instance fitted for external configurations and regular use
             */
            var exposeSafeLog = function exposeSafeLog($log) {
                return createLogObj($log, allowedMethods);
            };
            // add public methods to logEnhancerObj
            this.enhanceLogger = enhanceLogger;
            this.exposeSafeLog = exposeSafeLog;
        };
        //=======================================================================//
        // Configuration Section
        //=======================================================================//
        var logEnhancer = new logEnhancerObj();
        logEnhancer.enhanceLogger($delegate);

        // ensure false is being passed for production deployments
        // set to true for local development
        $delegate.enableLog(enableGlobally);

        if ($delegate.logEnabled()) {
            $delegate.log("CONFIG: LOGGING ENABLED GLOBALLY");
        }
        return logEnhancer.exposeSafeLog($delegate);
    }]);

    // Provider functions that will be exposed to allow overriding of default $logProvider functionality

    /**
     * Used externally to enable/disable logging globally
     * @param {boolean} flag - flag that sets whether logging is enabled/disabled
     */
    var enableLogging = function enableLogging(flag) {
        enableGlobally = isBoolean(flag) ? flag : false;
    };

    /**
     * Configure which log functions can be exposed at runtime
     * @param {*[]} arrMethods - list of methods that can be used
     */
    var restrictLogMethods = function restrictLogMethods(arrMethods) {
        if (angular.isArray(arrMethods)) {
            // TODO: should do validation on this to ensure valid properties are passed in
            allowedMethods = arrMethods;
        }
    };

    /**
     * Modify the default log prefix
     * @param {Function} logPrefix - function that defines the rule for a custom log prefix
     */
    var overrideLogPrefix = function overrideLogPrefix(logPrefix) {
        if (angular.isFunction(logPrefix)) {
            // TODO : Validation of the function to ensure it's of the correct format etc
            customLogPrefixFn = logPrefix;
            logPrefixOverride = true;
        }
    };

    /**
     * Turns off default coloring of logs
     * @param {boolean} flag - flag that configures disabling default log colors
     */
    var disableDefaultColors = function disableDefaultColors(flag) {
        useDefaultColors = isBoolean(flag) && flag ? false : true;
    };

    /**
     * Used to set a custom color to a specific $log method
     * @param {String} methodName - method name of the log method to assign a custom color
     * @param {String} colorCss - css string that defines what colour to be set for the specified log method
     */
    var setLogMethodColor = function setLogMethodColor(methodName, colorCss) {
        if (itypeof(methodName) === 'string' && defaultLogMethodColors.hasOwnProperty(methodName) && validateColorCssString(colorCss)) {

            defaultLogMethodColors[methodName] = colorCss;
        }
    };

    /**
     * Used to set custom colors to multiple $log method
     * @param {object} overrides - object that defines log method color overrides
     */
    var overrideLogMethodColors = function overrideLogMethodColors(overrides) {
        if (itypeof(overrides) === 'object') {
            angular.forEach(overrides, function (colorCss, method) {
                setLogMethodColor(method, colorCss);
            });
        }
    };

    /**
     * Used to force default log prefix functionality
     * @param {boolean} flag - when passed true, it forces log-ex to use the default log prefix
     */
    var useDefaultLogPrefix = function useDefaultLogPrefix(flag) {
        if (isBoolean(flag)) {
            useDefaultPrefix = flag;
        }
    };

    /**
     * Default $get method necessary for provider to work
     * @type {Function}
     */
    this.$get = function () {
        return {
            name: 'Log Unobtrusive Extension',
            version: '0.0.7',
            enableLogging: enableLogging,
            restrictLogMethods: restrictLogMethods,
            overrideLogPrefix: overrideLogPrefix,
            disableDefaultColors: disableDefaultColors,
            setLogMethodColor: setLogMethodColor,
            overrideLogMethodColors: overrideLogMethodColors,
            useDefaultLogPrefix: useDefaultLogPrefix
        };
    };

    // add methods to $provider
    this.enableLogging = enableLogging;
    this.overrideLogPrefix = overrideLogPrefix;
    this.restrictLogMethods = restrictLogMethods;
    this.disableDefaultColors = disableDefaultColors;
    this.setLogMethodColor = setLogMethodColor;
    this.overrideLogMethodColors = overrideLogMethodColors;
    this.useDefaultLogPrefix = useDefaultLogPrefix;
}]);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* @ngInject */

iceApplicationConfigLoaderFactory.$inject = ["moment", "$http", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceApplicationConfigLoaderFactory;
function iceApplicationConfigLoaderFactory(moment, $http, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceApplicationConfigLoader');

  return {
    getConfig: getConfig
  };

  function getConfig(opts) {
    var d = $q.defer();

    opts = opts || {};
    if (!opts.configResourceUrl) {
      d.reject(new Error('expected opts.configResourceUrl to be set.  got:' + opts.configResourceUrl));
      return d.promise;
    }

    var configResourceUrl = opts.configResourceUrl;
    var promise = $http({
      method: 'GET',
      url: configResourceUrl + '?ts=' + moment().format('x'),
      cache: false
    });

    promise.then(function (result) {
      d.resolve(result.data);
    }, function (err) {
      if (err && err.status == 404) {
        logger.error('configuration not found (404). [url: "' + configResourceUrl + '"]');
      } else {
        logger.error('getConfig()  http error:', arguments);
      }
      d.reject({
        code: 'APPLICATION_CONFIG__LOADER_ERR',
        cause: err
      });
    });

    return d.promise;
  }
}
module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




runnableConfigurationAutoLoader.$inject = ["iceApplicationConfigurator", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceApplicationConfiguratorProvider = exports.runnableConfigurationAutoLoader = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runnableConfigurationAutoLoader(iceApplicationConfigurator, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('runnableConfigurationLoader');

  LOGGER.info('autoLoadEnabled: ' + iceApplicationConfigurator.isAutoLoadEnabled());
  if (iceApplicationConfigurator.isAutoLoadEnabled()) {
    iceApplicationConfigurator.loadAndApplyConfiguration();
  }
}

function iceApplicationConfiguratorProvider() {
  'ngInject';

  // provider's private

  iceApplicationConfiguratorFactory.$inject = ["iceApplicationConfigLoader", "$injector", "_", "$q", "$log"];
  var autoLoadConfiguration = false;
  var providerConfig = {
    configResourceUrl: 'config/config.json',
    configurators: []
  };

  // provider's methods
  this.setConfigResourceUrl = setConfigResourceUrl;
  this.getConfigResourceUrl = getConfigResourceUrl;

  this.setConfigurators = setConfigurators;
  this.getConfigurators = getConfigurators;

  this.setAutoLoadEnabled = setAutoLoadEnabled;
  this.isAutoLoadEnabled = isAutoLoadEnabled;

  // public factory
  this.$get = iceApplicationConfiguratorFactory;

  // -- impl --

  function setConfigResourceUrl(url) {
    if (!_lodash2.default.isString(url)) {
      throw new Error('Expected url arg to be a string. got:' + (typeof url === 'undefined' ? 'undefined' : _typeof(url)));
    }
    providerConfig.configResourceUrl = url;
  }

  function getConfigResourceUrl() {
    return providerConfig.configResourceUrl;
  }

  function setConfigurators(configurators) {
    if (!_lodash2.default.isArray(configurators)) {
      throw new Error('Expected configurators arg to be an array. got:' + (typeof configurators === 'undefined' ? 'undefined' : _typeof(configurators)));
    }
    providerConfig.configurators = configurators;
  }

  function getConfigurators() {
    return _lodash2.default.cloneDeep(providerConfig.configurators);
  }

  function setAutoLoadEnabled(enabled) {
    autoLoadConfiguration = !!enabled;
  }

  function isAutoLoadEnabled() {
    return !!autoLoadConfiguration;
  }

  function iceApplicationConfiguratorFactory(iceApplicationConfigLoader, $injector, _, $q, $log) {
    'ngInject';

    var logger = $log.getInstance('iceApplicationConfigurator');

    var configurationState = {
      isRequired: false, // è stato richiesto il cariamento di una configurazione
      promise: null // promessa dell'effettiva applicazione della configurazione richiesta
    };

    // public export

    return {
      isAutoLoadEnabled: isAutoLoadEnabled,
      loadAndApplyConfiguration: loadAndApplyConfiguration,
      hasRequiredConfiguration: function hasRequiredConfiguration() {
        return !!configurationState.isRequired;
      },
      getRequiredConfigurationPromise: function getRequiredConfigurationPromise() {
        return configurationState.isRequired ? configurationState.promise : $q.when({});
      }
    };

    // impl

    function isAutoLoadEnabled() {
      return !!autoLoadConfiguration;
    }

    /**
     * Load and apply a configuration
     *
     * @param opts.configResourceUrl {String}
     * @returns {Promise}
     */
    function loadAndApplyConfiguration(opts) {
      logger.info('loadAndApplyConfiguration() opts:', opts);

      var defaultOpts = {
        configResourceUrl: providerConfig.configResourceUrl,
        configurators: createConfigurators()
      };
      opts = _.extend({}, defaultOpts, _.isObject(opts) ? opts : {});

      configurationState.isRequired = true;
      configurationState.promise = iceApplicationConfigLoader.getConfig(opts).then(function (configurationSpec) {
        return applyConfiguration('', configurationSpec, opts);
      }).then(null, function (error) {
        return $q.reject({
          code: 'E_APPLICATION_CONFIGURATOR',
          cause: error
        });
      });

      return $q.when(configurationState.promise);
    }

    function applyConfiguration(configurationName, configurationSpec, opts) {
      var configuratorPromises = [];
      var configurators = createConfigurators(opts.configurators);

      logger.log('applyConfiguration() spec:', configurationSpec, 'configurators:', configurators.length);

      _.forEach(configurators, function (configuratorImpl) {
        configuratorPromises.push(configuratorImpl.applyConfiguration(configurationName, configurationSpec));
      });

      logger.log('configuratorPromises:', configuratorPromises);
      return $q.all(configuratorPromises).then(function (result) {
        logger.log('All configurations applied successfully.');
        return $q.resolve(result);
      }, function (err) {
        logger.log('Error applying configuration "' + configurationName + '"', err);
        return $q.reject(err);
      });
    }

    function createConfigurators(configurators) {
      if (configurators) {
        logger.log('applyConfiguration() using custom configurators:', configurators);
      }

      return _.map(configurators || getConfigurators(), createConfigurator);
    }

    /**
     * Creates a configurator witch implements ConfiguratorInterface interface.
     * configuratorSpec can be:
     *  - a string: $injector is used (recursively)
     *  - a function: is assumed to be the applyConfiguration of the ConfiguratorInterface
     *  - an object that implements ConfiguratorInterface
     *
     * @param configuratorSpec {string|function|ConfiguratorInterface}
     * @param name {string}
     *
     * @throws if error occurs during the creation of the configurator that implements ConfiguratorInterface
     * @returns {ConfiguratorInterface}
     *
     *
     * @interface <ConfiguratorInterface> {
     *    getName(): String,
     *    applyConfiguration(configurationSpec): Promise
     * }
     *
     */
    function createConfigurator(configuratorSpec, name) {
      var configurator;

      if (_.isNumber(name)) {
        name = '[#number ' + name + ']';
      }

      if (_.isString(configuratorSpec)) {
        // obtain via $injector
        try {
          logger.log('createConfigurator() try resolving with $injector and apply recursion, configuratorSpec:', configuratorSpec);
          return createConfigurator($injector.get(configuratorSpec), configuratorSpec);
        } catch (e) {
          var error = new Error('Unable to $inject configurator from name "' + configuratorSpec + '"');
          error.cause = e;
          throw error;
        }
      } else if (_.isFunction(configuratorSpec)) {
        name = name || '[from function ' + configuratorSpec.name + ']';
        return new ConfiguratorWrapper(name, configuratorSpec);
      } else if (_.isObject(configuratorSpec)) {
        name = name || '[from Object ' + (configuratorSpec.name || configuratorSpec.getName && configuratorSpec.getName() || '') + ']';
        if (!_.isFunction(configuratorSpec.applyConfiguration)) {
          throw new Error('Configurator object is expected to have a method named applyConfiguration');
        }
        return new ConfiguratorWrapper(name, function applyConfigurationFnWrapper() {
          return configuratorSpec.applyConfiguration.apply(configuratorSpec, arguments);
        });
      } else {
        throw new Error('Unable to create ui configurator. Expected string, function or object but got ' + (typeof configurator === 'undefined' ? 'undefined' : _typeof(configurator)));
      }
    }

    function ConfiguratorWrapper(name, applyConfigurationFn) {
      this.getName = function () {
        return _.clone(name);
      };
      this.applyConfiguration = function () {
        logger.debug('applyConfiguration()  Configurator: ' + name);
        return applyConfigurationFn.apply(null, arguments);
      };
    }
  }
}

exports.runnableConfigurationAutoLoader = runnableConfigurationAutoLoader;
exports.iceApplicationConfiguratorProvider = iceApplicationConfiguratorProvider;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceCustomizationConfiguratorFactory.$inject = ["uiCustomizerConfig", "iceUICustomizer", "queryParamGetter", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceCustomizationConfiguratorFactory = iceCustomizationConfiguratorFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iceCustomizationConfiguratorFactory(uiCustomizerConfig, iceUICustomizer, queryParamGetter, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceCustomizationConfigurator');

  /**
   * Applica la customizzazione dichiarata nella configurazione fornita (configurationSpec).
   * Se non è indicata alcuna customizzazione E l'attributo "prevent-client-override" è falso:
   * viene caricata l'eventuale customizzazione indicata dal queryParam "ui"
   *
   * @override
   */
  return function applyConfiguration(configurationName, configurationSpec) {
    logger.log('applyConfiguration() configurationName:' + configurationName + ' spec:', configurationSpec);

    var loaderPromise = $q.when(); // start assuming OK

    var customizations = configurationSpec.customizations;
    var requiredCustomizationZone = 'default';
    var requiredCustomizationName = null;
    var requiredCustomizationOptions = {};

    if (customizations) {
      logger.log('customizations:', customizations);

      if (_lodash2.default.trim(customizations.path)) {
        logger.log('configuring base customizations path: "' + _lodash2.default.trim(customizations.path) + '"');
        uiCustomizerConfig.setCustomizationsSpecUrl(_lodash2.default.trim(customizations.path));
      }

      // check client required customization via queryParam "ui"  (if not denied by "prevent-client-override" property)

      if (!customizations['prevent-client-override']) {
        requiredCustomizationName = _lodash2.default.trim(queryParamGetter('ui', true)) || null;
        if (requiredCustomizationName) {
          requiredCustomizationOptions.isOptional = false; // when client explicitly requires a customization: this is mandatory!
          logger.log('got customization "' + requiredCustomizationName + '" from queryParam "ui"');
        } else {
          logger.log('no required customization from queryParam.');
        }
      } else {
        logger.info('"prevent-client-override":true -> customization via queryParam "ui" is disallowed by config.');
      }

      // check presence of static required customization via customizations.name property of configuration config.json

      if (!requiredCustomizationName && customizations.name) {
        requiredCustomizationName = customizations.name;
        requiredCustomizationOptions.isOptional = false; // when config.json explicitly requires a customization: this is mandatory!

        logger.info('got static customization from config: ' + requiredCustomizationName);
      }

      // check for dynamic customization name via host or context

      if (!requiredCustomizationName) {

        var defaultLoaderConfig = {
          "prefix": "host_",
          "exclusions": [],
          "mandatory": false
        };

        var loaderConfig = _lodash2.default.extend({}, defaultLoaderConfig, _lodash2.default.get(customizations, 'loaders.host') || {});
        if (loaderConfig.mandatory) {
          logger.info('loader host is configured to be mandatory.');
          requiredCustomizationOptions.isOptional = false;
        }
        var currentHost = _getHostname();

        if (loaderConfig.disabled) {
          logger.info('loader host is disabled by config.');
        } else {
          logger.log('loaderConfig exclusions: ', loaderConfig.exclusions);
          if (_lodash2.default.includes(loaderConfig.exclusions || [], currentHost)) {
            logger.info('current host "' + currentHost + '" is excluded by config.');
          } else {
            requiredCustomizationName = loaderConfig.prefix + _getHostname();

            logger.log('got customization "' + requiredCustomizationName + '" from loader "host"');
          }
        }
      }
    } else {
      logger.log('no customizations configuration to load.');
    }

    // configuring pec zone
    //uiCustomizerConfig
    var pecLoaderOptions = _lodash2.default.get(customizations, 'loaders.pec') || {};
    if (!customizations['prevent-client-override'] && _lodash2.default.trim(queryParamGetter('uiPec', true))) {
      pecLoaderOptions.enforcedCustomName = _lodash2.default.trim(queryParamGetter('uiPec', true));
      pecLoaderOptions.isOptional = false; // when client explicitly requires a customization: this is mandatory!
      logger.log('got enforced pecCustomization "' + pecLoaderOptions.enforcedCustomName + '" from queryParam "uiPec"');
    }
    if (pecLoaderOptions) {
      logger.debug('found "pec" loader options. setting via uiCustomizerConfig() .. options:', pecLoaderOptions);
      uiCustomizerConfig.setAdditionalConfiguration('pec', pecLoaderOptions);
    }

    if (requiredCustomizationName) {
      logger.info('Loading customization "' + requiredCustomizationName + '"  [zone:' + requiredCustomizationZone + ']  ..');

      try {
        iceUICustomizer.loadAndApplyCustomization(requiredCustomizationName, requiredCustomizationOptions, requiredCustomizationZone); // OK
      } catch (e) {
        logger.error('Error loading customization "' + requiredCustomizationName + '"  [zone:' + requiredCustomizationZone + ']', e);
        loaderPromise = $q.reject(e); // REJECT
      }
    }

    return loaderPromise;
  };

  function _getHostname() {
    return window.location.hostname;
  }
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



preferencesProviderHookConfigFn.$inject = ["iceApplicationPreferencesProvider"];
icePreferencesConfiguratorFactory.$inject = ["$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preferencesProvider = null;

function preferencesProviderHookConfigFn(iceApplicationPreferencesProvider) {
  'ngInject';

  preferencesProvider = iceApplicationPreferencesProvider;
}

function icePreferencesConfiguratorFactory($q, $log) {
  'ngInject';

  var logger = $log.getInstance('icePreferencesConfigurator');

  return applyConfiguration;

  /**
   * @override
   */
  function applyConfiguration(configurationName, configurationSpec) {
    logger.log('applyConfiguration() configurationName:' + configurationName + ' spec:', configurationSpec);

    var preferences = configurationSpec.preferences;
    var loaderPromise = $q.when(); // start assuming OK

    if (preferences) {
      logger.log('preferences:', preferences);

      try {
        preferencesProvider.setPreferences(preferences); // OK
      } catch (e) {
        loaderPromise = $q.reject(e); // REJECT
      }
    } else {
      logger.log('no preferences configuration to load.');
    }

    return loaderPromise;
  }
}

exports.preferencesProviderHookConfigFn = preferencesProviderHookConfigFn;
exports.icePreferencesConfiguratorFactory = icePreferencesConfiguratorFactory;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iceCustomizationConfigurator = __webpack_require__(9);

var _applicationConfigLoader = __webpack_require__(7);

var _applicationConfigLoader2 = _interopRequireDefault(_applicationConfigLoader);

var _icePreferencesConfigurator = __webpack_require__(10);

var _applicationConfigurator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.application-config', []).config(_icePreferencesConfigurator.preferencesProviderHookConfigFn).run(_applicationConfigurator.runnableConfigurationAutoLoader).provider('iceApplicationConfigurator', _applicationConfigurator.iceApplicationConfiguratorProvider).factory('icePreferencesConfigurator', _icePreferencesConfigurator.icePreferencesConfiguratorFactory).factory('iceApplicationConfigLoader', _applicationConfigLoader2.default).factory('iceCustomizationConfigurator', _iceCustomizationConfigurator.iceCustomizationConfiguratorFactory).name;
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




applicationIconsProviderHookConfig.$inject = ["iceApplicationIconsProvider"];
iceIconsCustomizerFactory.$inject = ["$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var iconsProvider = null;

function applicationIconsProviderHookConfig(iceApplicationIconsProvider) {
  'ngInject';

  iconsProvider = iceApplicationIconsProvider;
}

function iceIconsCustomizerFactory($q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceIconsCustomizer');

  return applyCustomization;

  /**
   * @override
   */
  function applyCustomization(customizationName, customizationSpec) {
    logger.log('applyCustomization() customizationName:' + customizationName + ' spec:', customizationSpec);

    var icons = customizationSpec.icons;
    var loaderPromise = $q.when(); // start assuming OK

    if (icons) {
      logger.log('icons:', icons);

      try {
        iconsProvider.setIcons(icons); // OK
      } catch (e) {
        loaderPromise = $q.reject(e); // REJECT
      }
    } else {
      logger.log('no css customization file to load.');
    }

    return loaderPromise;
  }
}

exports.applicationIconsProviderHookConfig = applicationIconsProviderHookConfig;
exports.iceIconsCustomizerFactory = iceIconsCustomizerFactory;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




applicationPreferencesProviderHookConfig.$inject = ["iceApplicationPreferencesProvider"];
icePreferencesCustomizerFactory.$inject = ["$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preferencesProvider = null;

function applicationPreferencesProviderHookConfig(iceApplicationPreferencesProvider) {
  'ngInject';

  preferencesProvider = iceApplicationPreferencesProvider;
}

function icePreferencesCustomizerFactory($q, $log) {
  'ngInject';

  var logger = $log.getInstance('icePreferencesCustomizer');

  return applyCustomization;

  /**
   * @override
   */
  function applyCustomization(customizationName, customizationSpec) {
    logger.log('applyCustomization() customizationName:' + customizationName + ' spec:', customizationSpec);

    var preferences = customizationSpec.preferences;
    var loaderPromise = $q.when(); // start assuming OK

    if (preferences) {
      logger.log('preferences:', preferences);

      try {
        preferencesProvider.setPreferences(preferences); // OK
      } catch (e) {
        loaderPromise = $q.reject(e); // REJECT
      }
    } else {
      logger.log('no preferences customization to load.');
    }

    return loaderPromise;
  }
}

exports.applicationPreferencesProviderHookConfig = applicationPreferencesProviderHookConfig;
exports.icePreferencesCustomizerFactory = icePreferencesCustomizerFactory;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




/* @ngInject */

iceStylesheetCustomizerFactory.$inject = ["uiCustomizerConfig", "iceUIStylesheetUtils", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
function iceStylesheetCustomizerFactory(uiCustomizerConfig, iceUIStylesheetUtils, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceStylesheetCustomizer');

  return {
    applyCustomization: applyCustomization
  };

  /**
   * @override
   */
  function applyCustomization(customizationName, customizationSpec) {
    logger.log('applyCustomization() customizationName:' + customizationName + ' spec:', customizationSpec);
    var loaderPromise;

    var cssFileName = customizationSpec.css;
    if (cssFileName) {
      logger.log('css customization file name: ' + cssFileName);

      var customizationsUrl = uiCustomizerConfig.getCustomizationsSpecUrl();
      var cssUrl = customizationsUrl + customizationName + '/' + cssFileName;

      loaderPromise = iceUIStylesheetUtils.appendStylesheet(cssUrl, customizationName);
    } else {
      logger.log('no css customization file to load.');
      loaderPromise = $q.when();
    }

    return loaderPromise;
  }
}

exports.iceStylesheetCustomizerFactory = iceStylesheetCustomizerFactory;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iceIconsCustomizer = __webpack_require__(12);

var _icePreferencesCustomizer = __webpack_require__(13);

var _iceStylesheetCustomizer = __webpack_require__(14);

var _uiCustomizationAutoLoaderRun = __webpack_require__(16);

var _uiCustomizationAutoLoaderRun2 = _interopRequireDefault(_uiCustomizationAutoLoaderRun);

var _uiCustomizer = __webpack_require__(17);

var _uiCustomizer2 = _interopRequireDefault(_uiCustomizer);

var _uiCustomizerConfig = __webpack_require__(18);

var _uiCustomizerConfig2 = _interopRequireDefault(_uiCustomizerConfig);

var _uiCustomizerSpecLoader = __webpack_require__(19);

var _uiCustomizerSpecLoader2 = _interopRequireDefault(_uiCustomizerSpecLoader);

var _uiCustomizerStylesheetUtils = __webpack_require__(20);

var _uiCustomizerStylesheetUtils2 = _interopRequireDefault(_uiCustomizerStylesheetUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.application-customizations', [])
// built-in customizers

.config(_iceIconsCustomizer.applicationIconsProviderHookConfig).factory('iceIconsCustomizer', _iceIconsCustomizer.iceIconsCustomizerFactory).config(_icePreferencesCustomizer.applicationPreferencesProviderHookConfig).factory('icePreferencesCustomizer', _icePreferencesCustomizer.icePreferencesCustomizerFactory).factory('iceStylesheetCustomizer', _iceStylesheetCustomizer.iceStylesheetCustomizerFactory).run(_uiCustomizationAutoLoaderRun2.default).factory('iceUICustomizer', _uiCustomizer2.default).provider('uiCustomizerConfig', _uiCustomizerConfig2.default).factory('iceUICustomizerSpecLoader', _uiCustomizerSpecLoader2.default).factory('iceUIStylesheetUtils', _uiCustomizerStylesheetUtils2.default).name;
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



uiCustomization_runFn.$inject = ["iceUICustomizer", "queryParamGetter"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uiCustomization_runFn;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function uiCustomization_runFn(iceUICustomizer, queryParamGetter) {
  'ngInject';

  if (_lodash2.default.trim(queryParamGetter('iceDebug', true))) {
    window.iceUICustomizer = iceUICustomizer;
  }
  var uiCustomizationName = _lodash2.default.trim(queryParamGetter('ui', true));

  if (uiCustomizationName) {
    console.log('required ui customization "' + uiCustomizationName + "'");
    //iceUICustomizer.loadAndApplyCustomization(uiCustomizationName);
  }
}
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



iceUICustomizerFactory.$inject = ["uiCustomizerConfig", "iceUICustomizerSpecLoader", "$injector", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = iceUICustomizerFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = __webpack_require__(2).Promise;

function iceUICustomizerFactory(uiCustomizerConfig, iceUICustomizerSpecLoader, $injector, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceUICustomizer');

  var DEFAULT_ZONE_NAME = 'default';

  var configurationState = {};

  function initCustomizationZoneState(zone, initialStateSpec) {
    var defaultZoneState = {
      //name: <zone-name>,
      isRequired: false, // è stato richiesto il caricamento di una personalizzazione
      promise: null, // promessa dell'effettiva applicazione della personalizzazione richiesta
      notFound: false // true se è stata eseguita la richiesta ma la personalizzazione non è stata trovata (GET config.json fallisce con statusCode 404)
    };

    var zoneState = _lodash2.default.merge({}, defaultZoneState, initialStateSpec);
    zoneState.name = zone;

    configurationState[zone] = zoneState;

    return zoneState;
  }

  // public export

  return {
    loadAndApplyCustomization: loadAndApplyCustomization,
    hasRequiredCustomization: hasRequiredCustomization,
    getRequiredCustomizationPromise: getRequiredCustomizationPromise
  };

  // impl


  function getZoneConfig(zone) {
    return uiCustomizerConfig.getZoneConfig(zone);
  }
  function getZoneCustomizers(zone) {
    return uiCustomizerConfig.getZoneCustomizers(zone);
  }

  function getZoneState(zone) {
    zone = zone || DEFAULT_ZONE_NAME;
    return configurationState[zone] || initCustomizationZoneState(zone);
  }

  function hasRequiredCustomization(zone) {
    logger.info('hasRequiredCustomization() [zone:' + zone + '] zoneState:', getZoneState(zone));
    return !!getZoneState(zone).isRequired;
  }
  function getRequiredCustomizationPromise(zone) {
    return getZoneState(zone).isRequired ? getZoneState(zone).promise : $q.when({});
  }

  function loadAndApplyCustomization(customizationName, opts, zone) {
    logger.info('loadAndApplyCustomization() [zone:' + zone + '] customizationName:' + customizationName + ' opts:', opts);

    var zoneConfig = uiCustomizerConfig.getZoneConfig(zone);
    var zoneState = getZoneState(zone);

    opts = _lodash2.default.extend({}, zoneConfig, _lodash2.default.isObject(opts) ? opts : {});

    zoneState.isRequired = true;
    logger.debug('loadAndApplyCustomization() [zone:' + zone + '] isRequired set to true! zoneState:', zoneState);
    zoneState.promise = iceUICustomizerSpecLoader.getCustomizationSpec(customizationName).then(function (customizationSpec) {
      return applyCustomization(customizationName, customizationSpec, opts);
    }).then(null, function (error) {

      if (error && error.subCode == 'NOT_FOUND') {

        if (opts.isOptional) {
          logger.info('loadAndApplyCustomization() [zone:' + zone + '] customization NOT FOUND. isOptional=true .. ignoring. OK.', zoneState);
          zoneState.notFound = true;
          return $q.resolve({ notFound: true });
        }
      }

      return Promise.reject({
        code: 'E_UI_CUSTOMIZATION',
        cause: error
      });
    });

    logger.debug('loadAndApplyCustomization() [zone:' + zone + '] zoneState:', zoneState);
    logger.debug('zoneConfig [' + zone + '] promise:', zoneState.promise);

    return $q.when(zoneState.promise);
  }

  function applyCustomization(customizationName, customizationSpec, opts) {
    var customizerPromises = [];
    var customizers = createCustomizers(opts.customizers);

    logger.log('applyCustomization() customizationName:' + customizationName + ' spec:', customizationSpec, 'customizers:', customizers.length);

    _lodash2.default.forEach(customizers, function (customizerImpl) {
      customizerPromises.push(customizerImpl.applyCustomization(customizationName, customizationSpec));
    });

    logger.log('customizerPromises:', customizerPromises);
    return $q.all(customizerPromises).then(function (result) {
      logger.log('All customizations applied successfully. result:', result);
      return $q.resolve(result);
    }, function (err) {
      logger.log('Error applying customization "' + customizationName + '"', err);
      return $q.reject(err);
    });
  }

  function createCustomizers(customizers, zone) {
    logger.log('createCustomizers() [zone:' + zone + ']');

    if (customizers) {
      logger.log('applyCustomization() using custom customizers:', customizers);
    }

    customizers = customizers || []; //getZoneCustomizers(zone);
    logger.log('createCustomizers() with customizers:', customizers);
    return _lodash2.default.map(customizers, createCustomizer);
  }

  /**
   * Creates a customizer witch implements CustomizerInterface interface.
   * customizerSpec can be:
   *  - a string: $injector is used (recursively)
   *  - a function: is assumed to be the applyCustomization of the CustomizerInterface
   *  - an object that implements CustomizerInterface
   *
   * @param customizerSpec {string|function|CustomizerInterface}
   * @param name {string}
   *
   * @throws if error occurs during the creation of the customizer that implements CustomizerInterface
   * @returns {CustomizerInterface}
   *
   *
   * @interface <CustomizerInterface> {
     *    getName(): String,
     *    applyCustomization(customizationSpec): Promise
     * }
   *
   */
  function createCustomizer(customizerSpec, name) {
    var customizer = void 0;

    if (_lodash2.default.isString(customizerSpec)) {
      // obtain via $injector
      try {
        return createCustomizer($injector.get(customizerSpec), customizerSpec);
      } catch (e) {
        var error = new Error('Unable to $inject customizer from name "' + customizerSpec + '"');
        error.cause = e;
        throw error;
      }
    } else if (_lodash2.default.isFunction(customizerSpec)) {
      name = name || '[from function ' + customizerSpec.name + ']';
      return new CustomizerWrapper(name, customizerSpec);
    } else if (_lodash2.default.isObject(customizerSpec)) {
      name = name || '[from Object ' + customizerSpec.name || customizerSpec.getName && customizerSpec.getName() + ']';
      if (!_lodash2.default.isFunction(customizerSpec.applyCustomization)) {
        throw new Error('Customizer object is expected to have a method named applyCustomization');
      }
      return new CustomizerWrapper(name, function applyCustomizationFnWrapper() {
        return customizerSpec.applyCustomization.apply(customizerSpec, arguments);
      });
    } else {
      throw new Error('Unable to create ui customizer. Expected string, function or object but got ' + (typeof customizer === 'undefined' ? 'undefined' : _typeof(customizer)));
    }
  }

  function CustomizerWrapper(name, applyCustomizationFn) {
    this.getName = function () {
      return _lodash2.default.clone(name);
    };
    this.applyCustomization = function () {
      logger.debug('applyCustomization()  Customizer: ' + name);
      return applyCustomizationFn.apply(null, arguments);
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



// @TODO rivedere get e set customizers: con l'introduzione della config per zone non ha + effetto

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uiCustomizerConfigProvider;
var CONFIG_DEFAULT_ZONE = 'default';
var providerConfig = {};

providerConfig['default'] = {
  configResourceUrl: 'customization/',
  customizers: ['icePreferencesCustomizer', 'iceIconsCustomizer', 'iceStylesheetCustomizer'],
  isOptional: true,
  endorsedOptions: {}
};

function _getZoneConfig(zone) {
  return providerConfig[zone || CONFIG_DEFAULT_ZONE] || providerConfig[CONFIG_DEFAULT_ZONE];
}
function getZoneCustomizers(zone) {
  return _.cloneDeep(_getZoneConfig(zone).customizers);
}

function setZoneConfig(zone, spec) {
  providerConfig[zone] = spec;
}

function uiCustomizerConfigProvider() {
  'ngInject';

  getPublicExports.$inject = ["$log"];
  var logger;

  var customizationsUrl = 'customizations/';

  var customizers = ['iceStylesheetCustomizer'];

  // provider exports
  this.setCustomizers = setCustomizers;
  this.getCustomizers = getCustomizers;
  this.getCustomizationsSpecUrl = getCustomizationsSpecUrl;
  this.setCustomizationsSpecUrl = setCustomizationsSpecUrl;
  this.getZoneConfig = _getZoneConfig;
  this.setZoneConfig = setZoneConfig;

  // public exports
  this.$get = getPublicExports;

  // impl

  /* @ngInject */
  function getPublicExports($log) {
    logger = $log.getInstance('uiCustomizerConfig');

    // additional configuration (used by custom loader)   INIT
    var additionalConfigurations = {};
    function setAdditionalConfiguration(name, conf) {
      logger.debug('setAdditionalConfiguration(name, conf)  name:' + name + '  conf:', conf);
      additionalConfigurations[name] = conf;
    }
    function getAdditionalConfiguration(name) {
      return _.cloneDeep(additionalConfigurations[name]);
    }
    // additional configuration (used by custom loader)   /END

    return {
      getCustomizationsSpecUrl: getCustomizationsSpecUrl,
      setCustomizationsSpecUrl: setCustomizationsSpecUrl,
      getCustomizers: getCustomizers,
      setCustomizers: setCustomizers,

      getZoneConfig: function getZoneConfig(zone) {
        return _.cloneDeep(_getZoneConfig(zone));
      },
      setZoneConfig: setZoneConfig,

      setAdditionalConfiguration: setAdditionalConfiguration,
      getAdditionalConfiguration: getAdditionalConfiguration
    };
  }

  function setCustomizers(customs) {
    customizers = customs;
  }

  function getCustomizers() {
    return customizers;
  }

  function getCustomizationsSpecUrl() {
    return customizationsUrl;
  }

  function setCustomizationsSpecUrl(url) {
    customizationsUrl = url;
  }
}
module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceUICustomizerSpecLoaderFactory.$inject = ["uiCustomizerConfig", "moment", "$http", "$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceUICustomizerSpecLoaderFactory;
function iceUICustomizerSpecLoaderFactory(uiCustomizerConfig, moment, $http, $q, $log) {
  'ngInject';

  var logger = $log.getInstance('iceUICustomizerSpecLoader');

  var customizationJsonHasDefaultName = true;

  return {
    getCustomizationSpec: getCustomizationSpec
  };

  function getCustomizationSpec(customizationName) {
    var d = $q.defer();

    var customizationsUrl = uiCustomizerConfig.getCustomizationsSpecUrl();
    var promise = $http({
      method: 'GET',
      url: customizationsUrl + customizationName + '/' + (customizationJsonHasDefaultName ? 'config' : customizationName) + '.json' + '?ts=' + moment().format('x'),
      cache: false
    });

    promise.then(function (result) {
      d.resolve(result.data);
    }, function (err) {
      var errorSubCode = null;
      var wasNotFound = err && err.status == 404;
      if (wasNotFound) {
        errorSubCode = 'NOT_FOUND';
        logger.error('customization not found (404). [name: "' + customizationName + '"]');
      } else {
        logger.error('getCustomizationSpec()  http error:', arguments);
      }
      d.reject({
        code: 'UI_CUSTOMIZER_SPEC_LOADER_ERR',
        subCode: errorSubCode,
        cause: err
      });
    });

    return d.promise;
  }
}
module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



iceUIStylesheetUtilsFactory.$inject = ["$q"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceUIStylesheetUtilsFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iceUIStylesheetUtilsFactory($q) {
  'ngInject';

  return {
    appendStylesheet: appendStylesheet,
    removeStyleSheetById: removeStyleSheetById,
    getDefaultMainAppStylesheet: getDefaultMainAppStylesheet
  };

  function appendStylesheet(path, id) {
    //$('head').append('<link href="'+path+'" rel="stylesheet" id="'+id+'" />');

    var d = $q.defer();

    loadStyleSheet(path, function (success, link) {
      if (success) {
        console.log('css loaded successfully! ' + link);
        d.resolve();
      } else {
        console.log('css not loaded :( ' + link);
        d.reject({
          code: 'UI_CUSTOMIZER_STYLESHEET_ERR',
          message: 'Unable to load stylesheet with path: ' + path
        });
      }
    });

    return d.promise;
  }

  function removeStyleSheetById(id) {
    $('#' + id).remove();
  }

  function getDefaultMainAppStylesheet() {
    return $('link[rel=stylesheet]').filter("[href$='app.css']");
  }
}

/**
 * Loads a stylesheet and notifies success or failure to a callback function
 *
 * @param href  string  stylesheet's url
 * @param callback F(success:boolean)
 * @param maxWaitMs number  how long to wait before failing (default: 15000)
 *
 * @see http://stackoverflow.com/questions/5537622/dynamically-loading-css-file-using-javascript-with-callback-without-jquery
 * @see full-version http://thudjs.tumblr.com/post/637855087/stylesheetonload-or-lack-thereof
 */
function loadStyleSheet(href, callback, maxWaitMs) {
  var head = document.getElementsByTagName('head')[0],
      // reference to document.head for appending/ removing link nodes
  link = document.createElement('link'); // create the link node

  maxWaitMs = maxWaitMs || 15000;

  link.setAttribute('href', href);
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('type', 'text/css');

  var sheet, cssRules;

  // get the correct properties to check for depending on the browser
  if ('sheet' in link) {
    sheet = 'sheet';
    cssRules = 'cssRules';
  } else {
    sheet = 'styleSheet';
    cssRules = 'rules';
  }

  var interval_id, timeout_id;

  interval_id = setInterval(function () {
    // start checking whether the style sheet has successfully loaded
    try {
      if (link[sheet] && link[sheet][cssRules].length) {
        // SUCCESS! our style sheet has loaded
        clearInterval(interval_id); // clear the counters
        clearTimeout(timeout_id);
        callback.call(null, true, link); // fire the callback with success == true
      }
    } catch (e) {} finally {}
  }, 100); // how often to check if the stylesheet is loaded

  timeout_id = setTimeout(function () {
    // start counting down till fail
    clearInterval(interval_id); // clear the counters
    clearTimeout(timeout_id);
    head.removeChild(link); // since the style sheet didn't load, remove the link node from the DOM
    callback.call(null, false, link); // fire the callback with success == false
  }, maxWaitMs); // how long to wait before failing

  head.appendChild(link); // insert the link node into the DOM and start loading the style sheet

  return link; // return the link node;
}
module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



iceApplicationIconDirective.$inject = ["$log", "iceApplicationIcons"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceApplicationIconDirective;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iceApplicationIconDirective($log, iceApplicationIcons) {
  'ngInject';

  var logger = $log.getInstance('iceApplicationIcon');
  var iconNameAttribute = 'iconName';

  // impl

  function applyIcon(element, icon, oldIcon) {
    if (oldIcon) {
      element.removeClass(oldIcon);
    }
    element.addClass(icon);
  }

  function link(scope, elem, attrs) {
    var icon;
    var targetElement = elem;

    attrs.$observe(iconNameAttribute, updateIcon);
    scope.$on(iceApplicationIcons.getIconsChangedNamespace(), updateIcon);

    // impl

    function updateIcon(newIconName) {
      //console.log(arguments);
      var oldIcon = icon;
      if (_lodash2.default.startsWith(newIconName, "'") && _lodash2.default.endsWith(newIconName, "'")) {
        // assumo un nome statico: retrocompatibilità..
        // aggiornare tutti i riferimenti sui template per non usare le stringhe ma semplicemente i valori
        // dato che ora ossero gli attributi con supporto a {{ }}  (se non usati il valore è già interpretato come stringa)
        logger.warn('iceApplicationIcon() using deprecated EVAL on scope (update template to remove \'\' around iconName value!');
        newIconName = scope.$eval(attrs[iconNameAttribute]);
      }

      icon = iceApplicationIcons.getIcon(newIconName);
      logger.log('updateIcon() name=' + newIconName + '  icon:' + icon);

      if (icon != oldIcon) applyIcon(targetElement, icon, oldIcon);
    }
  }

  return {
    restrict: 'EA',
    scope: true, // inherit
    transclude: true,
    link: link
  };
}
module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



runFn.$inject = ["$rootScope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceApplicationIconsProvider = exports.runFn = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $_rootScope = void 0;

function runFn($rootScope) {
  'ngInject';

  $_rootScope = $rootScope;
}

function iceApplicationIconsProvider() {
  var ICONS_CHANGED_NAMESPACE = 'iceApplicationIconsChanged';

  var iconsMap = {};
  var iconResolver = defaultIconResolver;

  // provider exports
  this.setIcon = setIcon;
  this.setIcons = setIcons;

  // PUBLIC object exports
  this.$get = makePublicExport;

  // impl

  function notifyIconsChanged() {
    if ($_rootScope) {
      $_rootScope.$broadcast(ICONS_CHANGED_NAMESPACE);
    } else {
      //console.log('event iceApplicationIconsChanged cannot be broadcasted: $rootScope is not available yet.');
    }
  }

  /**
   * Ogni valore 'icon-class' può iniziare con $ ad indicare che il valore è la chiave di un'altra icona
   * Ogni valore 'icon-class' può terminare con !default: l'icona verrà definita solo se non già definita prima (replica comportamento sass)
   *
   * @param icons       mappa 'icon-name' => 'icon-class'
   * @param alsoClean   se true elimina tutte le eventuali icone gia definite
   */
  function setIcons(icons, alsoClean) {
    var oldIcons = _lodash2.default.clone(iconsMap);
    var isDefault;

    if (alsoClean) {
      iconsMap = {};
    }
    if (_lodash2.default.isObject(icons)) {
      _lodash2.default.forEach(icons, function (icon, key) {
        isDefault = _lodash2.default.endsWith(icon, '!default'); // ie: 'my-icon !default'
        if (isDefault) {
          icon = icon.split('!')[0]; // parte sinistra di 'my-icon !default'
        }

        if (!isDefault || !getIcon(key)) {
          iconsMap[key] = _lodash2.default.trim(icon);
        }
      });
    }

    if (!_lodash2.default.isEqual(oldIcons, iconsMap)) {
      notifyIconsChanged();
    }
  }

  function setIcon(name, icon) {
    var oldIcon = iconsMap[name];
    var isDefault = _lodash2.default.endsWith(icon, '!default'); // ie: 'my-icon !default'

    if (isDefault) {
      icon = icon.split('!')[0]; // parte sinistra di 'my-icon !default'
    }

    if (!isDefault || !getIcon(name)) {
      iconsMap[name] = _lodash2.default.trim(icon);
    }

    if (oldIcon != icon) {
      notifyIconsChanged();
    }
  }

  function defaultIconResolver(iconName) {
    //console.log('defaultIconResolver(iconName) iconName:'+iconName);
    //console.log(iconsMap);

    iconName = _lodash2.default.trim(iconName);

    var icon = iconsMap[iconName];
    if (_lodash2.default.isString(icon) && _lodash2.default.startsWith(icon, '$')) {
      icon = defaultIconResolver(icon.substr(1));
    }

    return icon; // || iconsMap.DEFAULT
  }

  function getIcon(name) {
    return iconResolver(name);
  }

  function getIconsChangedNamespace() {
    return ICONS_CHANGED_NAMESPACE;
  }

  /* @ngInject */
  function makePublicExport() {
    return {
      getIconsChangedNamespace: getIconsChangedNamespace,
      getIcon: getIcon
    };
  }
}

exports.runFn = runFn;
exports.iceApplicationIconsProvider = iceApplicationIconsProvider;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _applicationIcons = __webpack_require__(22);

var _applicationIcon = __webpack_require__(21);

var _applicationIcon2 = _interopRequireDefault(_applicationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.application-icons', []).run(_applicationIcons.runFn).provider('iceApplicationIcons', _applicationIcons.iceApplicationIconsProvider).directive('iceApplicationIcon', _applicationIcon2.default).name;
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




exposeWithDebug_runFn.$inject = ["iceApplicationPreferences", "queryParamGetter"];
runFn.$inject = ["$rootScope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceApplicationPreferencesProvider = exports.exposeWithDebug_runFn = exports.runFn = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $_rootScope = void 0;

function exposeWithDebug_runFn(iceApplicationPreferences, queryParamGetter) {
  'ngInject';

  if (_lodash2.default.trim(queryParamGetter('iceDebug', true))) {
    window.iceApplicationPreferences = iceApplicationPreferences;
  }
}

function runFn($rootScope) {
  'ngInject';

  $_rootScope = $rootScope;
}

function iceApplicationPreferencesProvider() {
  'ngInject';

  makePublicExport.$inject = ["$log"];
  var CHANGED_NAMESPACE = 'iceApplicationPreferencesChanged';
  var LOGGER = window.console || { log: function log() {} };

  var preferencesMap = {};
  var preferencesResolver = defaultPreferencesResolver;

  // provider exports
  this.setReplacer = setReplacer;
  this.setOnePref = setPref;
  this.has = hasPref;
  this.setPreferences = setPreferences;

  var replaceCtx = {
    '%_PREF-EMPTY-IMG_%': 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
  };

  // PUBLIC object exports
  this.$get = makePublicExport;

  // impl

  /* @ngInject */
  function makePublicExport($log) {
    'ngInject';

    LOGGER = $log.getInstance('iceApplicationPreferences');

    return {
      getPreferencesChangedNamespace: getPreferencesChangedNamespace,
      hasPref: hasPref,
      getPref: getPref,
      getPrefAsBoolean: getPrefAsBoolean,
      getGroups: getGroups,
      getPrefNames: getKeys,
      filterPref: filterPref
    };
  }

  /**
   * Ogni valore 'value' può contenere dei meta-tag che vengono rimpiazzati a runtime.
   *
   * @see setReplacer
   * @see replaceCtx
   *
   * @param preferencess       mappa 'name' => 'value'
   * @param alsoClean   se true elimina tutte le eventuali preferenze gia definite
   */
  function setPreferences(preferencess, alsoClean) {
    var oldPreferences = _lodash2.default.clone(preferencesMap);

    if (alsoClean) {
      preferencesMap = {};
    }
    if (_lodash2.default.isObject(preferencess)) {
      _lodash2.default.forEach(preferencess, function (v, k) {
        _doSetPref(k, v);
      });
    }

    if (!_lodash2.default.isEqual(oldPreferences, preferencesMap)) {
      _notifyChanged();
    }
  }

  function hasPref(name) {
    return !!_lodash2.default.isString(preferencesMap[name]);
  }

  function setPref(name, value) {
    if (_doSetPref(name, value)) {
      _notifyChanged();
    }
  }

  /**
   * Imposta la preferenza fornita.
   * Restituisce true se il valore passato è diverso dall'eventuale precedente.
   *
   * @param name
   * @param value
   * @returns {boolean} true if value differs from previous
   * @private
   */
  function _doSetPref(name, value) {
    //LOGGER.trace('_doSetPref ## ', name, value);
    var oldValue = preferencesMap[name];
    var isDefault = _lodash2.default.endsWith(value, '!default'); // ie: 'my-value !default'


    if (isDefault) {
      value = value.split('!')[0]; // parte sinistra di 'my-value !default'
    }

    if (!isDefault || !getPref(name)) {
      preferencesMap[name] = _lodash2.default.trim(value);
    }

    preferencesMap[name] = _lodash2.default.trim(value);

    return oldValue != value;
  }

  function defaultPreferencesResolver(name) {
    //LOGGER.log('defaultPreferencesResolver(name) name:'+name);
    //LOGGER.log(preferencesMap);

    name = _lodash2.default.trim(name);

    var value = preferencesMap[name];
    if (_lodash2.default.isString(value) && _lodash2.default.startsWith(value, '$')) {
      value = defaultPreferencesResolver(value.substr(1));
    }

    value = _preferencesEnvReplacer(value);

    return value; // || preferencesMap.DEFAULT
  }

  function getPref(name) {
    return preferencesResolver(name);
  }

  function getPrefAsBoolean(name) {
    var v = getPref(name);
    return v && v == 'true' || v == '1';
  }

  function getKeys() {
    return _lodash2.default.keys(preferencesMap);
  }

  function getGroups(propertyNameStartingPart, collectPropertiesEndParts) {
    return _lodash2.default.map(_collectGroupIds(propertyNameStartingPart), function (groupID) {
      return _buildGroup(propertyNameStartingPart, groupID, collectPropertiesEndParts);
    });
  }

  var _groupConstructor = function () {
    function groupConstructor(groupID, groupSpec) {
      return {
        _id: getId(),
        _keys: getKeys(),

        getId: getId,
        getKeys: getKeys,
        hasKey: hasKey,
        getValue: getValue
      };

      function getId() {
        return groupID;
      }

      function hasKey(key) {
        return _lodash2.default.has(groupSpec, key);
      }

      function getKeys() {
        return _lodash2.default.keys(groupSpec);
      }

      function getValue(key) {
        return _lodash2.default.has(groupSpec, key) ? groupSpec[key] : null;
      }
    }

    return groupConstructor;
  }();

  function _buildGroup(propertyNameStartingPart, groupID, collectPropertiesEndParts) {
    var groupSpec = {};

    // support projection STRING  => pre-transform to array
    if (_lodash2.default.isString(collectPropertiesEndParts)) {
      collectPropertiesEndParts = collectPropertiesEndParts.split(',');
      collectPropertiesEndParts = _lodash2.default.map(collectPropertiesEndParts, _lodash2.default.trim);
    }

    // support array  => transforming to map
    if (_lodash2.default.isArray(collectPropertiesEndParts)) {
      // convert array to object map   preferenceProperty => outputProperty
      var map = {};
      _lodash2.default.forEach(collectPropertiesEndParts, function (key) {
        map[key] = key;
      });
      collectPropertiesEndParts = map;
    }

    if (_lodash2.default.isObject(collectPropertiesEndParts)) {
      // colleziono le property indicate da collectPropertiesEndParts
      LOGGER.log('_buildGroup(): using projection properties:', collectPropertiesEndParts);
      _lodash2.default.forEach(collectPropertiesEndParts, function (outputPropertyName, propertyEndPart) {
        groupSpec[outputPropertyName] = getPref(propertyNameStartingPart + groupID + '.' + propertyEndPart);
      });
    } else {
      LOGGER.log('_buildGroup(): no projection properties. capturing all group properties..');
      var matchStart = propertyNameStartingPart + groupID + '.';
      var matchStartStrlen = matchStart.length;
      _lodash2.default.forEach(getKeys(), function (key) {
        if (_lodash2.default.startsWith(key, matchStart)) {
          var propertyName = key.slice(matchStartStrlen);
          groupSpec[propertyName] = getPref(key);
        }
      });
    }

    LOGGER.log('_buildGroup:', groupID, groupSpec);
    return _groupConstructor(groupID, groupSpec);
  }

  function _collectGroupIds(preferenceNameStartingPart) {
    var expectedGroupIDIndex = preferenceNameStartingPart.split('.').length - 1;

    function getRuleID(key) {
      var keyParts = ('' + key).split('.');
      return keyParts.length > expectedGroupIDIndex ? keyParts[expectedGroupIDIndex] : null;
    }

    var ruleIDs = _lodash2.default.reduce(getKeys(), function (memo, prefName) {
      if (_lodash2.default.startsWith(prefName, preferenceNameStartingPart)) {
        var ruleID = getRuleID(prefName);
        if (ruleID) {
          memo[ruleID] = 1;
        }
      }
      return memo;
    }, {});

    var ids = _lodash2.default.keys(ruleIDs);

    if (_lodash2.default.includes(ids, 'default')) {
      _lodash2.default.remove(ids, function (id) {
        return id == 'default';
      });
      ids.push('default'); // insert "default" at the end
    }

    LOGGER.log('SORTED:', _lodash2.default.sortBy(ids));

    return ids;
  }

  function filterPref(predicate) {
    return _lodash2.default.filter(getKeys(), predicate);
  }

  function getPreferencesChangedNamespace() {
    return CHANGED_NAMESPACE;
  }

  function setReplacer(search, replace) {
    replaceCtx[search] = replace;
  }

  function _preferencesEnvReplacer(str) {
    if (!_lodash2.default.isString(str)) {
      return null;
    }

    _lodash2.default.forEach(replaceCtx, function (v, k) {
      //LOGGER.log(' ##REPLACE ##', str, k, v);
      str = _replaceAll(str, k, v);
    });

    return str;
  }

  /**
   * @private
   */
  function _notifyChanged() {
    if ($_rootScope) {
      $_rootScope.$broadcast(CHANGED_NAMESPACE);
    } else {
      //LOGGER.log('event iceApplicationPreferences cannot be broadcasted: $rootScope is not available yet.');
    }
  }

  function _escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  }
  function _replaceAll(str, find, replacement) {
    return str.split(_escapeRegExp(find)).join(replacement);
  }
}

exports.runFn = runFn;
exports.exposeWithDebug_runFn = exposeWithDebug_runFn;
exports.iceApplicationPreferencesProvider = iceApplicationPreferencesProvider;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceExposePreferencesAs;
function iceExposePreferencesAs(iceApplicationPreferences) {
  /* @ngInject */

  link.$inject = ["$scope", "element", "attrs"];
  function link($scope, element, attrs) {
    var exposeObj = {};
    exposeObj.hasPref = exposeObj.hasKey = exposeObj.getPref = iceApplicationPreferences.hasKey;
    exposeObj.getPref = iceApplicationPreferences.getPref;

    var exposeAs = attrs['iceExposePreferencesAs'] || 'icePref';
    $scope[exposeAs] = exposeObj;
  }

  return {
    restrict: 'AC',
    link: link
  };
}
module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _applicationPreferences = __webpack_require__(24);

var _exposePreferencesAs = __webpack_require__(25);

var _exposePreferencesAs2 = _interopRequireDefault(_exposePreferencesAs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.application-preferences', []).run(_applicationPreferences.runFn).run(_applicationPreferences.exposeWithDebug_runFn).provider('iceApplicationPreferences', _applicationPreferences.iceApplicationPreferencesProvider).directive('iceExposePreferencesAs', _exposePreferencesAs2.default).name;
module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



StateChangePreconditionsExecutorFactory.$inject = ["$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StateChangePreconditionsExecutorFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
function StateChangePreconditionsExecutorFactory($q, $log) {
  var BASE_LOGGER = $log.getInstance('StateChangePreconditionsExecutor');
  var instanceCount = 0;

  return StateChangePreconditionsExecutor;

  function qualifiedLogger() {
    return BASE_LOGGER;

    instanceCount++;

    var logger = {};

    _lodash2.default.forEach(BASE_LOGGER, function (v, k) {
      logger[k] = function () {
        var arg0 = '[' + instanceCount + ']  ' + _lodash2.default.first(arguments);
        var restArgs = _lodash2.default.rest(arguments);
        var args = [].concat([arg0]).concat(restArgs);
        BASE_LOGGER[k].apply(BASE_LOGGER, args);
      };
    });

    return logger;
  }

  /**
   * Esegue le precondizioni in ordine.
   * Se una precondizione viene risolta, si passa alla successiva;
   * La risoluzione dell'ultima precondizione risolve anche l'esecuzione complessiva.
   * Quando una precondizione viene rigettata, l'intera esecuzione è rigettata
   * Se viene invocato abort() la promessa di esecuzione viene abortita con il parametro fornito e non verranno invocate le rimanenti precondizioni
   *
   * @returns {{
   *    abort(reason:*): void,
   *    isAborted(): boolean,
   *    getStateTransition(): StateTransitionBean,
   *    execute(preconditions:[], stateTransition:StateTransitionBean): Promise,
   *    promise: Promise
   * }}
   * @constructor
   */
  function StateChangePreconditionsExecutor() {
    if (!(this instanceof StateChangePreconditionsExecutor)) {
      return new StateChangePreconditionsExecutor();
    }

    var LOGGER = qualifiedLogger();
    LOGGER.log('created.');

    var deferredExecution = $q.defer(),
        aborted = false,
        currentPrecondition = null,
        preconditionsIterator = null,
        stateTransition = null;

    return {
      abort: abort,
      isAborted: isAborted,
      getStateTransition: getStateTransition,
      execute: execute,
      promise: deferredExecution.promise
    };

    function abort() {
      LOGGER.log('abort()');
      aborted = true;
      if (deferredExecution) deferredExecution.reject({
        aborted: true
      });
      if (currentPrecondition && currentPrecondition.abort) {
        try {
          currentPrecondition.abort();
        } catch (e) {
          LOGGER.error(e);
        }
      }
    }

    function isAborted() {
      return !!aborted;
    }

    function getStateTransition() {
      return stateTransition;
    }

    function execute(preconditions, _stateTransition_) {
      LOGGER.log('execute(preconditions, stateTransition)\n', preconditions, '\n', _stateTransition_);
      if (stateTransition) {
        throw new Error('execute() already called. It can be called only once per instance.');
      }

      stateTransition = _stateTransition_;
      preconditionsIterator = preconditionsIteratorFactory(preconditions);

      _iterate();

      return deferredExecution.promise;
    }

    function _iterate() {
      if (!preconditionsIterator.hasNext()) return _handleNoMorePreconditions();

      currentPrecondition = preconditionsIterator.next();
      if (!currentPrecondition.instance.matchesTransition(stateTransition)) {
        LOGGER.debug('_iterate() SKIP precondition "' + currentPrecondition.name + '": does\'nt match transition.');
        return _iterate();
      }

      LOGGER.debug('_iterate() evaluating precondition "' + currentPrecondition.name + "' ..");
      currentPrecondition.instance.evaluateTransition(stateTransition).then(_handlePreconditionResult, _handlePreconditionRejection);
    }

    function _handlePreconditionResult(result) {
      if (!aborted) {
        LOGGER.debug('_handlePreconditionResult(result)', result);
        _iterate();
      }
    }

    function _handlePreconditionRejection(rejection) {
      if (!aborted) {
        LOGGER.debug('_handlePreconditionRejection(rejection)', rejection);

        deferredExecution.reject({
          errorCode: 'E_PRECONDITION_FAILED',
          cause: {
            preconditionName: currentPrecondition.name,
            rejection: rejection
          }
        });
      }
    }

    function _handleNoMorePreconditions() {
      if (!aborted) {
        LOGGER.debug('_handleNoMorePreconditions(): successfully resolving execution..');
        deferredExecution.resolve();
      }
    }
  }
}

/**
 * Simple preconditions iterator
 *
 * @param collection Array<stateChangePrecondition>
 * @returns {{
 *    hasNext(): boolean,
 *    current(): object,
 *    next(): object        can be null
 * }}
 */
function preconditionsIteratorFactory(collection) {
  var i = 0;
  collection = _lodash2.default.isArray(collection) ? collection : [];

  return {
    hasNext: hasNext,
    current: current,
    next: next
  };

  function hasNext() {
    return i < collection.length;
  }

  function current() {
    return i < collection.length ? collection[i] : null;
  }

  function next() {
    return i < collection.length ? collection[i++] : null;
  }
}
module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



attachStateChangeStartHandler_runFn.$inject = ["StateChangePreconditionsManager", "$rootScope", "$log"];
router1_attachStateChangeStartHandler_runFn.$inject = ["StateChangePreconditionsManager", "$transitions", "$log"];
StateChangePreconditionsManagerFactory.$inject = ["applicationTransitionStateChangePreconditions", "StateTransitionBean", "StateChangePreconditionsExecutor", "$state", "$rootScope", "$injector", "$q", "$log", "notifier"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateChangePreconditionsManagerFactory = exports.attachStateChangeStartHandler_runFn = undefined;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = __webpack_require__(2).Promise;

exports.attachStateChangeStartHandler_runFn = router1_attachStateChangeStartHandler_runFn;
exports.StateChangePreconditionsManagerFactory = StateChangePreconditionsManagerFactory;


function attachStateChangeStartHandler_runFn(StateChangePreconditionsManager, $rootScope, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('StateChangePreconditionsManager~Setup');

  LOGGER.info('attaching $stateChangeStart handler');
  $rootScope.$on('$stateChangeStart', StateChangePreconditionsManager.stateChangeStartHandler);
}

function router1_attachStateChangeStartHandler_runFn(StateChangePreconditionsManager, $transitions, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('StateChangePreconditionsManager~Setup router1');

  LOGGER.info('attaching $stateChangeStart handler');
  $transitions.onStart({/*all transitions*/}, StateChangePreconditionsManager.stateChangeStartHandler_router1);
}

function StateChangePreconditionsManagerFactory(applicationTransitionStateChangePreconditions, StateTransitionBean, StateChangePreconditionsExecutor, $state, $rootScope, $injector, $q, $log, notifier) {
  'ngInject';

  var LOGGER = $log.getInstance('StateChangePreconditionsManager');

  var currentExecutor = void 0;

  /**
   * To be attached at $rootScope.$on('$stateChangeStart')
   */
  return {
    stateChangeStartHandler: stateChangeStartHandler,
    stateChangeStartHandler_router1: stateChangeStartHandler_router1
  };

  // impl
  function stateChangeStartHandler_router1(transition) {
    LOGGER.log("Transition from " + transition.from().name + " to " + transition.to().name, transition);

    var excludedTargetStates = {
      FECON_PRECONDITION_FAILED: true,
      FECON_CUSTOMIZATION_ERROR: true
    };

    if (excludedTargetStates[transition.to().name]) {
      LOGGER.log("Target state " + transition.to().name + ' is marked as excluded by PreconditionManager. SKIP preconditions check.');
      return;
    }

    var newStateTransition = new StateTransitionBean({
      transition: transition
    });

    if (currentExecutor) {
      LOGGER.debug('stateChangeStartHandler_router1() aborting previous stateChange executor..');
      // scarta il risultato dell'esecutore: gli impedisce di risolvere/rigettare la promessa
      currentExecutor.abort();
    }

    var preconditions = _getPreconditions();
    var firstActivePre = _lodash2.default.find(preconditions, function (pre) {
      return pre.instance.matchesTransition(transition);
    });
    if (!firstActivePre) {
      LOGGER.info('no precondition matches transition');
      return; // transition continues
    }

    currentExecutor = new StateChangePreconditionsExecutor();

    LOGGER.debug('stateChangeStartHandler_router1() running executor.. ', currentExecutor);
    var promise = new Promise(function (resolve, reject) {
      currentExecutor.execute(preconditions, newStateTransition).then(router1_handleExecutorResult, router1__handleExecutorRejection).then(resolve, reject);
    });

    LOGGER.debug('stateChangeStartHandler_router1() running executor - promise:', promise);

    return promise;
  }

  function router1_handleExecutorResult(result) {
    LOGGER.debug('router1_handleExecutorResult(result)', result);
    LOGGER.info('STATE_CHANGE OK -> RESUME');

    currentExecutor = null; // cleanup
    return result;
  }

  function router1__handleExecutorRejection(rejection) {
    if (_lodash2.default.get(rejection, 'aborted') == true) {
      /**
       Nothing to do: this is a rejection result from invoking executor.abort()
       @see .abort() into _handleStateChangeStart
       */
      LOGGER.debug('router1__handleExecutorRejection(rejection): got previous executor rejection. that\'s ok. ignoring it.', rejection);
      return;
    }

    LOGGER.error('router1__handleExecutorRejection(rejection)', rejection);
    var stateTransition = currentExecutor.getStateTransition();
    var transition = stateTransition.getTransition();
    var paramsCopy = Object.assign({}, transition.params());
    var stateService = transition.router.stateService;
    currentExecutor = null; // cleanup

    if (_lodash2.default.get(rejection, 'errorCode') == 'E_PRECONDITION_FAILED') {
      var failedPreconditionName = _lodash2.default.get(rejection, 'cause.preconditionName');
      var requiredStateChange = _lodash2.default.get(rejection, 'cause.rejection.requiredStateChange');
      var rejectionBehaviourAlreadyHandled = _lodash2.default.get(rejection, 'cause.rejection.behaviourAlreadyHandled');
      LOGGER.error('STATE_CHANGE PRECONDITION FAILED "' + failedPreconditionName + '" ' + stateTransition, rejection);

      if (requiredStateChange) {
        LOGGER.debug('_handleExecutorRejection() executor result wants to change state.. requiredStateChange:', requiredStateChange);
        return stateService.target(requiredStateChange.toState, requiredStateChange.toParams, requiredStateChange.withOptions);
      } else if (_lodash2.default.get(rejection, 'cause.rejection.code') == 'E_UI_CUSTOMIZATION') {
        // TODO questo blocco dovrebbe essere normalizzato nella precondizione:
        // TODO deve valorizzare cause.rejection.requiredStateChange per essere gestito nel blocco precedente
        return Promise.resolve(stateService.target('FECON_CUSTOMIZATION_ERROR'));
      } else if (!rejectionBehaviourAlreadyHandled) {
        LOGGER.debug('_handleExecutorRejection() emitting E_STATE_CHANGE_PRECONDITION_REJECTED..');
        var event = $rootScope.$broadcast('E_STATE_CHANGE_PRECONDITION_REJECTED', {
          stateTransition: stateTransition,
          preconditionName: failedPreconditionName,
          rejection: rejection
        });
        if (!event.defaultPrevented) {
          LOGGER.debug('_handleExecutorRejection() E_STATE_CHANGE_PRECONDITION_REJECTED was not handled (no one has set preventDefault). Redirecting to FECON_PRECONDITION_FAILED ..');
          // $stateChangeError args signature: toState, toParams, fromState, fromParams, error
          notifier.error('Error');
          return Promise.resolve(stateService.target('FECON_PRECONDITION_FAILED'));
          //return Promise.reject(rejection);
        }
      } else {
        LOGGER.debug('_handleExecutorRejection() rejection is handled internally by precondition itself: ok, nothing to do!');
      }
    } else {
      // internal execution error :|
      LOGGER.error('_handleExecutorRejection() :( unhandled rejection :( rejection:\n', rejection);
      notifier.error('Sorry, requested transition failed.');
      return false; // abort router transition
    }
  }

  function stateChangeStartHandler(event, toState, toParams, fromState, fromParams, options) {
    var newStateTransition = new StateTransitionBean({
      event: event,
      toState: toState,
      toParams: toParams,
      fromState: fromState,
      fromParams: fromParams,
      options: options
    });

    LOGGER.info('STATE_CHANGE INIT ' + newStateTransition, newStateTransition);

    _pauseTransition(newStateTransition);
    _handleStateChangeStart(newStateTransition);
  }

  function _handleStateChangeStart(newStateTransition) {
    if (currentExecutor) {
      LOGGER.debug('_handleStateChangeStart() aborting previous stateChange executor..');
      // scarta il risultato dell'esecutore: gli impedisce di risolvere/rigettare la promessa
      currentExecutor.abort();
    }

    var preconditions = _getPreconditions();
    currentExecutor = new StateChangePreconditionsExecutor();
    //currentExecutor.abort();// @TODO REMOVE ME - I'm A TEST!
    LOGGER.debug('_handleStateChangeStart() running executor.. ', currentExecutor);
    currentExecutor.execute(preconditions, newStateTransition).then(_handleExecutorResult, _handleExecutorRejection);
  }

  function _handleExecutorResult(result) {
    LOGGER.debug('_handleExecutorResult(result)', result);
    LOGGER.info('STATE_CHANGE OK -> RESUME');

    var currentStateTransition = currentExecutor.getStateTransition();
    currentExecutor = null; // cleanup

    _resumeTransition(currentStateTransition);
  }

  function _handleExecutorRejection(rejection) {
    if (_lodash2.default.get(rejection, 'aborted') == true) {
      /**
       Nothing to do: this is a rejection result from invoking executor.abort()
       @see .abort() into _handleStateChangeStart
      */
      LOGGER.debug('_handleExecutorRejection(rejection): got previous executor rejection. that\'s ok. ignoring it.', rejection);
      return;
    }

    LOGGER.error('_handleExecutorRejection(rejection)', rejection);
    var stateTransition = currentExecutor.getStateTransition();
    currentExecutor = null; // cleanup

    if (_lodash2.default.get(rejection, 'errorCode') == 'E_PRECONDITION_FAILED') {
      var failedPreconditionName = _lodash2.default.get(rejection, 'cause.preconditionName');
      var requiredStateChange = _lodash2.default.get(rejection, 'cause.rejection.requiredStateChange');
      var rejectionBehaviourAlreadyHandled = _lodash2.default.get(rejection, 'cause.rejection.behaviourAlreadyHandled');
      LOGGER.error('STATE_CHANGE PRECONDITION FAILED "' + failedPreconditionName + '" ' + stateTransition, rejection);

      if (requiredStateChange) {
        LOGGER.debug('_handleExecutorRejection() executor result wants to change state.. requiredStateChange:', requiredStateChange);
        $state.go(requiredStateChange.toState, requiredStateChange.toParams, requiredStateChange.withOptions);
      } else if (!rejectionBehaviourAlreadyHandled) {
        LOGGER.debug('_handleExecutorRejection() emitting E_STATE_CHANGE_PRECONDITION_REJECTED..');
        var event = $rootScope.$broadcast('E_STATE_CHANGE_PRECONDITION_REJECTED', {
          stateTransition: stateTransition,
          preconditionName: failedPreconditionName,
          rejection: rejection
        });
        if (!event.defaultPrevented) {
          // $stateChangeError args signature: toState, toParams, fromState, fromParams, error
          $rootScope.$broadcast('$stateChangeError', stateTransition.getToState(), stateTransition.getToParams(), stateTransition.getFromState(), stateTransition.getFromParams(), rejection);
        }
      } else {
        LOGGER.debug('_handleExecutorRejection() rejection is handled internally by precondition itself: ok, nothing to do!');
      }
    } else {
      // internal execution error :|
      LOGGER.error('_handleExecutorRejection() :( unhandled rejection :( rejection:\n', rejection);
    }
  }

  function _pauseTransition(stateTransition) {
    LOGGER.debug('_pauseTransition(stateTransition) pausing ', stateTransition);
    stateTransition.getEvent().preventDefault(); // prevent router transition
  }

  function _resumeTransition(stateTransition) {
    LOGGER.debug('_resumeTransition(stateTransition) resuming ', stateTransition);

    var options = _lodash2.default.merge({}, stateTransition.getOptions(), { notify: false });
    //delete options.notify; // TODO IT'S A TEST!

    $state.go(stateTransition.getToState().name, stateTransition.getToParams(), options).then(function () {
      $rootScope.$broadcast('$stateChangeSuccess', stateTransition.getToState(), stateTransition.getToParams(), stateTransition.getFromState(), stateTransition.getFromParams(), stateTransition.getOptions());
    });
    //$timeout(function() { $urlRouter.sync(); },250);
  }

  function _getPreconditions() {
    var preconditions = _lodash2.default.map(applicationTransitionStateChangePreconditions, function (precondName) {
      return {
        name: precondName,
        instance: $injector.get(precondName)
      };
    });

    LOGGER.debug('preconditions:', preconditions);
    return preconditions;
  }
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StateTransitionBeanFactory;
function StateTransitionBeanFactory() {
  'ngInject';

  return StateTransitionBean;

  function StateTransitionBean(spec) {

    spec = spec || {};

    var transition = spec.transition,
        event = spec.event,
        fromState = spec.fromState,
        fromParams = spec.fromParams,
        toState = spec.toState,
        toParams = spec.toParams,
        options = spec.options;

    return {
      getTransition: getTransition,

      getEvent: getEvent,
      setEvent: setEvent,

      getFromState: getFromState,
      setFromState: setFromState,

      getFromParams: getFromParams,
      setFromParams: setFromParams,

      getToState: getToState,
      setToState: setToState,

      getToParams: getToParams,
      setToParams: setToParams,

      getOptions: getOptions,
      setOptions: setOptions,

      toString: toString
    };

    function getTransition() {
      return transition;
    }

    function getEvent() {
      return event;
    }

    function setEvent(evt) {
      event = evt;
    }

    function getFromState() {
      return transition ? transition.from().name : fromState;
    }

    function setFromState(state) {
      fromState = state;
    }

    function getToState() {
      return transition ? transition.to().name : toState;
    }

    function setToState(state) {
      toState = state;
    }

    function getFromParams() {
      return fromParams;
    }

    function setFromParams(params) {
      fromParams = params;
    }

    function getToParams() {
      return toParams;
    }

    function setToParams(params) {
      toParams = params;
    }

    function getOptions() {
      return options;
    }

    function setOptions(opts) {
      options = opts;
    }

    function toString() {
      if (transition) {
        return '' + transition;
      }
      return 'StateTransitionBean{ from "' + getFromState().name + '"  to: "' + getToState().name + '" }';
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preconditions = __webpack_require__(31);

var _preconditions2 = _interopRequireDefault(_preconditions);

var _assureApplicationConfigStateChangePrecondition = __webpack_require__(32);

var _assureApplicationConfigStateChangePrecondition2 = _interopRequireDefault(_assureApplicationConfigStateChangePrecondition);

var _assureApplicationCustomizationStateChangePrecondition = __webpack_require__(33);

var _assureApplicationCustomizationStateChangePrecondition2 = _interopRequireDefault(_assureApplicationCustomizationStateChangePrecondition);

var _authenticationProtectorStateChangePrecondition = __webpack_require__(34);

var _authenticationProtectorStateChangePrecondition2 = _interopRequireDefault(_authenticationProtectorStateChangePrecondition);

var _StateChangePreconditionsExecutor = __webpack_require__(27);

var _StateChangePreconditionsExecutor2 = _interopRequireDefault(_StateChangePreconditionsExecutor);

var _StateChangePreconditionsManager = __webpack_require__(28);

var _StateTransitionBean = __webpack_require__(29);

var _StateTransitionBean2 = _interopRequireDefault(_StateTransitionBean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.application-state-preconditions', []).constant('applicationTransitionStateChangePreconditions', _preconditions2.default).run(_StateChangePreconditionsManager.attachStateChangeStartHandler_runFn).factory('assureApplicationConfig.stateChangePrecondition', _assureApplicationConfigStateChangePrecondition2.default).factory('assureApplicationCustomization.stateChangePrecondition', _assureApplicationCustomizationStateChangePrecondition2.default).factory('authenticationProtector.stateChangePrecondition', _authenticationProtectorStateChangePrecondition2.default)
//.factory('moduleAuthorizationProtector', moduleAuthorizationProtector)
.factory('StateChangePreconditionsExecutor', _StateChangePreconditionsExecutor2.default).factory('StateChangePreconditionsManager', _StateChangePreconditionsManager.StateChangePreconditionsManagerFactory).factory('StateTransitionBean', _StateTransitionBean2.default).name;
//import moduleAuthorizationProtector from './preconditions/moduleAuthorizationProtector.stateChangePrecondition.factory';

module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Claudio Germani
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
var applicationTransitionStateChangePreconditions = [
//'genericStateChangePrecondition',
'assureApplicationConfig.stateChangePrecondition', 'assureApplicationCustomization.stateChangePrecondition'];

exports.default = applicationTransitionStateChangePreconditions;
module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



applicationConfigPreconditionFactory.$inject = ["iceApplicationConfigurator"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applicationConfigPreconditionFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
function applicationConfigPreconditionFactory(iceApplicationConfigurator) {

  /**
   * matchesTransition(stateTransition:StateTransitionBean): bool     <true if transition needs to be checked by this precondition>
   * evaluateTransition(stateTransition:StateTransitionBean): Promise
   */
  return {
    matchesTransition: matchesTransition,
    evaluateTransition: evaluateTransition
  };

  // impl

  function matchesTransition(stateTransition) {
    return iceApplicationConfigurator.hasRequiredConfiguration();
  }

  function evaluateTransition(stateTransition) {
    return iceApplicationConfigurator.getRequiredConfigurationPromise();
  }
}
module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



applicationCustomizationPreconditionFactory.$inject = ["iceUICustomizer"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applicationCustomizationPreconditionFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
function applicationCustomizationPreconditionFactory(iceUICustomizer) {

  /**
   * matchesTransition(stateTransition:StateTransitionBean): bool     <true if transition needs to be checked by this precondition>
   * evaluateTransition(stateTransition:StateTransitionBean): Promise
   */
  return {
    matchesTransition: matchesTransition,
    evaluateTransition: evaluateTransition
  };

  // impl

  function matchesTransition(stateTransition) {
    return iceUICustomizer.hasRequiredCustomization();
  }

  function evaluateTransition(stateTransition) {
    return iceUICustomizer.getRequiredCustomizationPromise();
  }
}
module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Claudio Germani
 */



authenticationProtectorPreconditionFactory.$inject = ["$q", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = authenticationProtectorPreconditionFactory;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
function authenticationProtectorPreconditionFactory($q, /*iceApplicationUser, authentication,*/$log) {
  var LOGGER = $log.getInstance('authenticationProtectorPrecondition');

  /**
   * matchesTransition(stateTransition:StateTransitionBean): bool     <true if transition needs to be checked by this precondition>
   * evaluateTransition(stateTransition:StateTransitionBean): Promise
   */
  return {
    matchesTransition: matchesTransition,
    evaluateTransition: evaluateTransition
  };

  // impl

  /**
   * Uno stato che richiede autenticazione ha la proprietà data.authRequired: true
   * Le proprietà dell'oggetto data vengono ereditate: quindi è possibile definire authRequired in un padre comune a più stati
   *
   * @param stateTransition
   * @returns {boolean}
     */
  function matchesTransition(stateTransition) {
    return false;
  }

  function evaluateTransition(stateTransition) {
    return authentication.checkAuthentication().then(function (result) {
      if (result && result.authenticated) {
        // OK
        LOGGER.info('authenticated');
        return $q.resolve('authenticated');
      } else {
        // KO
        return $q.reject({
          requiredStateChange: {
            toState: 'login',
            toParams: null
          }
        });
      }
    }, function () {
      return $q.reject({
        requiredStateChange: {
          toState: 'login',
          toParams: null
        }
      });
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileDetector;
function MobileDetector() {
  var UA = navigator.userAgent;

  // @see http://www.abeautifulsite.net/detecting-mobile-devices-with-javascript/
  // per una versione migliore:
  // - @see https://github.com/kaimallea/isMobile/blob/master/isMobile.js
  // - @see *** https://github.com/hgoebl/mobile-detect.js
  // redirect mobile: @see https://github.com/sebarmeli/JS-Redirection-Mobile-Site
  var isMobile = {
    Android: function Android() {
      return UA.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
      return UA.match(/BlackBerry/i);
    },
    iOS: function iOS() {
      return UA.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
      return UA.match(/Opera Mini/i);
    },
    Windows: function Windows() {
      return UA.match(/IEMobile/i);
    },
    // @see https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
    GenericMobile: function GenericMobile() {
      return UA.match(/Mobi/i);
    },
    any: function any() {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() || isMobile.GenericMobile();
    }
  };

  return {
    isMobile: isMobile.any,
    isIOS: isMobile.iOS
  };
}
module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/**

 ice-mobile OR ice-desktop
 ice-touch
 ice-2x OR ice-1x
 ice-portrait OR ice-landscape
 ice-screen OR ice-print
 ice-mode-full OR ice-mode-reduced OR ice-mode-small
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var iceLayoutClassesMap = {
  MOBILE: 'ice-mobile',
  DESKTOP: 'ice-desktop',
  TOUCH: 'ice-touch',

  IOS: 'ice-ios',

  RETINA: 'ice-2x',
  NO_RETINA: 'ice-1x',

  LANDSCAPE: 'ice-landscape',
  PORTRAIT: 'ice-portrait',

  SCREEN: 'ice-screen',
  PRINT: 'ice-print',

  MODE_FULL: 'ice-mode-full',
  MODE_REDUCED: 'ice-mode-reduced',
  MODE_SMALL: 'ice-mode-small'
};

var iceLayoutModesEnum = {
  FULL: 'FULL',
  REDUCED: 'REDUCED',
  SMALL: 'SMALL'
};

exports.iceLayoutClassesMap = iceLayoutClassesMap;
exports.iceLayoutModesEnum = iceLayoutModesEnum;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(79);

var _deviceDetector = __webpack_require__(35);

var _deviceDetector2 = _interopRequireDefault(_deviceDetector);

var _deviceUtils = __webpack_require__(36);

var _layoutClasses = __webpack_require__(38);

var _layoutClasses2 = _interopRequireDefault(_layoutClasses);

var _layoutStatus = __webpack_require__(40);

var _layoutStatus2 = _interopRequireDefault(_layoutStatus);

var _layoutModePublish = __webpack_require__(39);

var _layoutModePublish2 = _interopRequireDefault(_layoutModePublish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.device-utils', ['matchmedia-ng'])
/* Esposto come costante per renderlo iniettabile anche in fase config() */
.constant('iceDeviceDetector', (0, _deviceDetector2.default)()).constant('iceLayoutClassesMap', _deviceUtils.iceLayoutClassesMap).constant('iceLayoutModesEnum', _deviceUtils.iceLayoutModesEnum).factory('iceLayoutStatus', _layoutStatus2.default).directive('iceLayoutClasses', _layoutClasses2.default).directive('iceLayoutModePublish', _layoutModePublish2.default).name;
module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/**
 * Aggancia le classi iceLayoutClassesMap all'elemento su cui è applicato. (Tipicamente il body)
 * Le classi vengono aggiornate automaticamente
 */

iceLayoutClassesDirective.$inject = ["iceDeviceDetector", "iceLayoutClassesMap", "iceLayoutModesEnum", "iceLayoutStatus", "$timeout", "matchmedia", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
function iceLayoutClassesDirective(iceDeviceDetector, iceLayoutClassesMap, iceLayoutModesEnum, iceLayoutStatus, $timeout, matchmedia, $log) {
  'ngInject';

  link.$inject = ["scope", "element", "attrs"];
  var log = $log.getInstance('iceLayoutClasses');

  var element, userAgent, isPrint, isScreen, isRetina, isMobile, isPhone, isTablet, isIOS, isPortrait, isLandscape, mode;

  evaluateStatic();

  // impl

  function getLayoutMode() {
    if (checkSMALL()) return 'SMALL';
    if (checkREDUCED()) return 'REDUCED';

    return 'FULL';
  }
  function checkFULL() {
    return !isMobile && matchmedia.is('min-width: 768px');
  }
  function checkREDUCED() {
    return isMobile && isLandscape || matchmedia.is('max-width: 767px');
  }
  function checkSMALL() {
    return isMobile && isPortrait;
  }

  function evaluateStatic() {
    // static rules
    isMobile = _isMobile();
    isRetina = matchmedia.is('only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)');
    isIOS = _isIOS();
  }

  /* @ngInject */
  function link(scope, element, attrs) {
    log.debug('linking to element', element);

    var classToggler = createClassToggler(element);
    var modeChangeHandler = createModeChangeHandler(element);

    // static rules

    classToggler(isMobile, iceLayoutClassesMap.MOBILE, iceLayoutClassesMap.DESKTOP);
    classToggler(isRetina, iceLayoutClassesMap.RETINA, iceLayoutClassesMap.NO_RETINA);
    classToggler(isIOS, iceLayoutClassesMap.IOS, '');

    // dynamic rules

    iceLayoutStatus.onModeChange(modeChangeHandler);

    $timeout(function () {
      attachDynmicRules(classToggler);
    });
  }

  function attachDynmicRules(classToggler) {
    matchmedia.onLandscape(function (mediaQueryList) {
      isLandscape = !!mediaQueryList.matches;
      isPortrait = !isLandscape;

      classToggler(isLandscape, iceLayoutClassesMap.LANDSCAPE, iceLayoutClassesMap.PORTRAIT);
    });

    matchmedia.onScreen(function (mediaQueryList) {
      isScreen = !!mediaQueryList.matches;

      classToggler(isScreen, iceLayoutClassesMap.SCREEN);
    });

    matchmedia.onPrint(function (mediaQueryList) {
      isPrint = !!mediaQueryList.matches;

      classToggler(isPrint, iceLayoutClassesMap.PRINT);
    });
  }

  function createModeChangeHandler(element) {
    return function (mode) {
      var add, remove;
      switch (mode) {
        case iceLayoutModesEnum.FULL:
          add = iceLayoutClassesMap.MODE_FULL;
          remove = [iceLayoutClassesMap.MODE_REDUCED, iceLayoutClassesMap.MODE_SMALL];
          break;

        case iceLayoutModesEnum.REDUCED:
          add = iceLayoutClassesMap.MODE_REDUCED;
          remove = [iceLayoutClassesMap.MODE_FULL, iceLayoutClassesMap.MODE_SMALL];
          break;

        case iceLayoutModesEnum.SMALL:
          add = iceLayoutClassesMap.MODE_SMALL;
          remove = [iceLayoutClassesMap.MODE_FULL, iceLayoutClassesMap.MODE_REDUCED];
          break;
      }

      element.addClass(add);

      _.forEach(remove, function (removeClass) {
        element.removeClass(removeClass);
      });
    };
  }

  function createClassToggler(element) {
    return function toggleExclusiveClass(truthy, classForTruthy, classForFalsy) {
      if (truthy) {

        if (classForTruthy) log.debug(' + ' + classForTruthy);
        if (classForFalsy) log.debug(' - ' + classForFalsy);

        element.addClass(classForTruthy).removeClass(classForFalsy);
      } else {

        if (classForTruthy) log.debug(' - ' + classForTruthy);
        if (classForFalsy) log.debug(' + ' + classForFalsy);

        element.removeClass(classForTruthy).addClass(classForFalsy);
      }
    };
  }

  function _isMobile() {
    return iceDeviceDetector.isMobile();
  }

  function _isIOS() {
    return iceDeviceDetector.isIOS();
  }

  return {
    link: link
  };
}

exports.default = iceLayoutClassesDirective;
module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



iceLayoutModePublishDirective.$inject = ["iceLayoutStatus", "iceSafeApply", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
function iceLayoutModePublishDirective(iceLayoutStatus, iceSafeApply, $log) {
  'ngInject';

  var logger = $log.getInstance('iceLayoutModePublish');

  logger.log('registered.');

  return {
    restrict: 'EAC',
    link: function link(scope, elm, attrs) {
      logger.log('linking..');

      var publishAs = attrs['iceLayoutModePublish'] || 'layoutMode';
      logger.log('linked. publishAs: ', publishAs);

      var deregister = iceLayoutStatus.onModeChange(update);
      scope.$on('$destroy', deregister);

      update(iceLayoutStatus.getLayoutMode());

      function update(mode) {
        logger.log('update() ..');
        iceSafeApply(function () {
          scope.$eval(publishAs + '="' + mode + '"');
        }, scope);
      }
    }
  };
}

exports.default = iceLayoutModePublishDirective;
module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



iceLayoutStatusFactory.$inject = ["iceDeviceDetector", "iceLayoutModesEnum", "matchmedia", "iceSafeApply", "$timeout", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function iceLayoutStatusFactory(iceDeviceDetector, iceLayoutModesEnum, matchmedia, iceSafeApply, $timeout, $log) {
  'ngInject';

  var logger = $log.getInstance('iceLayoutStatus');

  var LAYOUT_MODES = iceLayoutModesEnum;

  var isPrint = void 0,
      isScreen = void 0,
      isRetina = void 0,
      isMobile = void 0,
      isPhone = void 0,
      isTablet = void 0,
      isPortrait = false,
      isLandscape = true,
      mode = 'FULL';

  var MODE_CUSTOM_RULE = {
    LARGE_SCREEN: '(min-width: 768px)',
    MEDIUM_SCREEN: '(min-width: 768px) and (max-width: 1099px)',
    SMALL_SCREEN: '(max-width: 767px)'
  };

  var modeSubscribers = [];
  var somethingChangedHandler = createSometingChangedHandler();
  var lastNotifiedMode = void 0;

  evaluateStatic();
  $timeout(function () {
    attach(somethingChangedHandler);
  });

  // impl


  function computeLayoutMode() {
    logger.log('computing layout mode..');
    if (checkSMALL()) return LAYOUT_MODES.SMALL;
    if (checkREDUCED()) return LAYOUT_MODES.REDUCED;

    return LAYOUT_MODES.FULL;
  }
  function checkFULL() {
    return !isMobile && matchmedia.is(MODE_CUSTOM_RULE.LARGE_SCREEN);
  }
  function checkREDUCED() {
    return isMobile && isLandscape || matchmedia.is(MODE_CUSTOM_RULE.MEDIUM_SCREEN);
  }
  function checkSMALL() {
    return isMobile && isPortrait || matchmedia.is(MODE_CUSTOM_RULE.SMALL_SCREEN);
  }

  function checkForChanges() {
    mode = computeLayoutMode();
    fireModeChange();

    return;

    if (mode != lastNotifiedMode) {
      lastNotifiedMode = mode;
      fireModeChange();
    }
  }

  function unsubscriber(fn) {
    return function () {
      logger.log('actual count: ' + modeSubscribers.length);
      logger.log('removed modeListener: ', _.remove(modeSubscribers, function (subscr) {
        return subscr == fn;
      }));
      logger.log('remaining: ' + modeSubscribers.length);
    };
  }
  function onModeChange(fn) {
    if (!_.isFunction(fn)) {
      throw new Error('onModeChange expects a function as argument. got: ' + (typeof fn === 'undefined' ? 'undefined' : _typeof(fn)), fn);
    }
    modeSubscribers.push(fn);
    //logger.debug('onModeChange() attached listener #'+(modeSubscribers.length-1), fn);
    return unsubscriber(fn);
  }
  function fireModeChange() {
    logger.debug('fireModeChange() ..');
    //logger.debug('fireModeChange() ['+modeSubscribers.length+']  mode: '+mode+' subscribers:',modeSubscribers);
    var i = 0;
    var subscribers = _.clone(modeSubscribers);
    _.forEach(subscribers, function (fn) {
      //logger.debug('fireModeChange() call #'+(i++)+'', typeof fn, fn);
      try {
        fn(mode);
      } catch (e) {
        logger.error(e);
      }
    });
    iceSafeApply(function () {});
  }

  function createSometingChangedHandler() {
    return _.debounce(checkForChanges, 50);
  }

  function setInitialState() {
    if (!isMobile) {
      mode = LAYOUT_MODES.FULL;
      isPortrait = false;
      isLandscape = true;
    }

    somethingChangedHandler();
  }

  function evaluateStatic() {
    // static rules
    isMobile = _isMobile();
    isRetina = matchmedia.is('only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)');

    setInitialState();
  }

  function attach(onChangeFn) {
    logger.debug('attach()');

    // dynamic rules

    matchmedia.onLandscape(function (mediaQueryList) {
      isLandscape = !!mediaQueryList.matches;
      isPortrait = !isLandscape;

      onChangeFn();
    });

    matchmedia.onScreen(function (mediaQueryList) {
      isScreen = !!mediaQueryList.matches;

      onChangeFn();
    });

    matchmedia.onPrint(function (mediaQueryList) {
      isPrint = !!mediaQueryList.matches;

      onChangeFn();
    });

    _.forEach(MODE_CUSTOM_RULE, function (ruleValue, name) {
      matchmedia.on(ruleValue, function (mediaQueryList) {
        onChangeFn();
      });
    });
  }

  function _isMobile() {
    return iceDeviceDetector.isMobile();
  }

  return {
    getLayoutMode: function getLayoutMode() {
      return mode;
    },
    isFull: function isFull() {
      return mode == LAYOUT_MODES.FULL;
    },
    isReduced: function isReduced() {
      return mode == LAYOUT_MODES.REDUCED;
    },
    isSmall: function isSmall() {
      return mode == LAYOUT_MODES.SMALL;
    },
    is: function is(checkMode) {
      return mode == checkMode;
    },
    onModeChange: onModeChange
  };
}

exports.default = iceLayoutStatusFactory;
module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _logger = __webpack_require__(42);

var _logger2 = _interopRequireDefault(_logger);

var _notifier = __webpack_require__(44);

var _notifier2 = _interopRequireDefault(_notifier);

var _deviceUtils = __webpack_require__(37);

var _deviceUtils2 = _interopRequireDefault(_deviceUtils);

var _applicationPreferences = __webpack_require__(26);

var _applicationPreferences2 = _interopRequireDefault(_applicationPreferences);

var _applicationIcons = __webpack_require__(23);

var _applicationIcons2 = _interopRequireDefault(_applicationIcons);

var _applicationConfig = __webpack_require__(11);

var _applicationConfig2 = _interopRequireDefault(_applicationConfig);

var _applicationCustomization = __webpack_require__(15);

var _applicationCustomization2 = _interopRequireDefault(_applicationCustomization);

var _applicationStatePreconditions = __webpack_require__(30);

var _applicationStatePreconditions2 = _interopRequireDefault(_applicationStatePreconditions);

var _xsrf = __webpack_require__(67);

var _xsrf2 = _interopRequireDefault(_xsrf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular-bundle', [_utils2.default, _logger2.default, _notifier2.default, _deviceUtils2.default, _applicationPreferences2.default, _applicationIcons2.default, _applicationConfig2.default, _applicationCustomization2.default, _applicationStatePreconditions2.default, _xsrf2.default]).name;

/*
import _queryParamGetter from './utils/utils.services/queryparam.getter';
export const queryParamGetter = _queryParamGetter;
*/

module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// commented with "replaced in path": import angular from 'angular';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _logger = __webpack_require__(43);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import third party libraries non ES6 compliant
__webpack_require__(6);

exports.default = angular.module('infocert.js.angular.logger', ['log.ex.uo', _utils2.default]).config(_logger2.default).name;
module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



// util

loggerConfig.$inject = ["queryParamGetter", "logExProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var iceConsoleWrapperUtil = {
  preventAllLog: function preventAllLog() {
    (function (global) {
      'use strict';

      global.console = global.console || {};
      var con = global.console;
      var prop = void 0,
          method = void 0;
      var empty = {};
      var dummy = function dummy() {};
      var properties = 'memory'.split(',');
      var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' + 'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' + 'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
      while (prop = properties.pop()) {
        if (!con[prop]) con[prop] = empty;
      }while (method = methods.pop()) {
        // unica modifica al polyfill originale: rimpiazzo tutto con dummy (sia che esisteva una funzione sia che non esisteva)
        if (method != 'error') {
          con[method] = dummy;
        }
      }
      // Using `this` for web workers & supports Browserify / Webpack.
    })(typeof window === 'undefined' ? this : window);
  }
};

function loggerConfig(queryParamGetter, logExProvider) {
  'ngInject';

  // @see https://github.com/lwhiteley/AngularLogExtender

  var enableLogging = !!queryParamGetter('iceLog', true);

  if (!enableLogging) {
    iceConsoleWrapperUtil.preventAllLog();
  }

  logExProvider.enableLogging(enableLogging);

  var $injector = angular.injector(['ng']);
  var $filter = $injector.get('$filter');
  var separator = ' >> ';
  var format = 'yyyy-MM-dd HH:mm:ss.sss';

  logExProvider.overrideLogPrefix(function (className) {
    var now = $filter('date')(new Date(), format);
    return '' + now + (!angular.isString(className) ? '' : ' :: ' + className + '') + separator;
  });
}

exports.default = loggerConfig;
module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// commented with "replaced in path": import angular from 'angular';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = __webpack_require__(81);

var _toastr2 = _interopRequireDefault(_toastr);

var _angularAnimate = __webpack_require__(78);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _toastrContainer = __webpack_require__(46);

var _toastrContainer2 = _interopRequireDefault(_toastrContainer);

var _notifier = __webpack_require__(45);

var _notifier2 = _interopRequireDefault(_notifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('infocert.js.angular._toastr_wrapper', []).constant('toastr', _toastr2.default);

exports.default = angular.module('infocert.js.angular.notifier', [_angularAnimate2.default, 'infocert.js.angular._toastr_wrapper']).config(_toastrContainer2.default).factory('notifier', _notifier2.default).name;
module.exports = exports['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


notifierFactory.$inject = ["$log", "toastr"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/CodeSeven/toastr
 */
function notifierFactory($log, toastr) {
  'ngInject';

  var logger = $log.getInstance('notifier');

  var defaultOptions = {
    "preventDuplicates": true,
    "progressBar": false,
    "positionClass": "toast-top-center",

    "showDuration": "100",
    "hideDuration": "100",
    "timeOut": "2000",
    "extendedTimeOut": "1000"
  };

  _lodash2.default.merge(toastr.options, defaultOptions);

  return {
    success: function success(message, title, options) {
      toastr.success.apply(toastr, arguments);
    },
    info: function info(message, title, options) {
      toastr.info.apply(toastr, arguments);
    },
    error: function error(message, title, options) {
      toastr.error.apply(toastr, arguments);
    },
    warning: function warning(message, title, options) {
      toastr.warning.apply(toastr, arguments);
    },
    warn: function warn(message, title, options) {
      toastr.warning.apply(toastr, arguments);
    },

    log: function log(message, title, options) {
      logger.log.call(logger, 'log', message, title, options);
    },
    trace: function trace(message, title, options) {
      logger.log.call(logger, 'trace', message, title, options);
    }
  };
}

exports.default = notifierFactory;
module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


toastrConfig.$inject = ["toastr"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toastrConfig;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toastrConfig(toastr) {
  'ngInject';

  /**
   * @see https://github.com/CodeSeven/toastr
   */

  var localOptions = {
    autoDismiss: false,
    containerId: 'toast-container',
    maxOpened: 0,
    newestOnTop: true,
    positionClass: 'toast-bottom-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    target: 'body'
  };

  _lodash2.default.merge(toastr.options, localOptions);
}
module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function base64_encode(str) {
  if (window.btoa) // Internet Explorer 10 and above
    return window.btoa(unescape(encodeURIComponent(str)));else {
    // Cross-Browser Method (compressed)

    // Create Base64 Object
    var Base64 = {
      _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      encode: function encode(e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
          n = e.charCodeAt(f++);
          r = e.charCodeAt(f++);
          i = e.charCodeAt(f++);
          s = n >> 2;
          o = (n & 3) << 4 | r >> 4;
          u = (r & 15) << 2 | i >> 6;
          a = i & 63;
          if (isNaN(r)) {
            u = a = 64;
          } else if (isNaN(i)) {
            a = 64;
          }
          t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
        }
        return t;
      },
      decode: function decode(e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
          s = this._keyStr.indexOf(e.charAt(f++));
          o = this._keyStr.indexOf(e.charAt(f++));
          u = this._keyStr.indexOf(e.charAt(f++));
          a = this._keyStr.indexOf(e.charAt(f++));
          n = s << 2 | o >> 4;
          r = (o & 15) << 4 | u >> 2;
          i = (u & 3) << 6 | a;
          t = t + String.fromCharCode(n);
          if (u != 64) {
            t = t + String.fromCharCode(r);
          }
          if (a != 64) {
            t = t + String.fromCharCode(i);
          }
        }
        t = Base64._utf8_decode(t);
        return t;
      },
      _utf8_encode: function _utf8_encode(e) {
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
          } else if (r > 127 && r < 2048) {
            t += String.fromCharCode(r >> 6 | 192);
            t += String.fromCharCode(r & 63 | 128);
          } else {
            t += String.fromCharCode(r >> 12 | 224);
            t += String.fromCharCode(r >> 6 & 63 | 128);
            t += String.fromCharCode(r & 63 | 128);
          }
        }
        return t;
      },
      _utf8_decode: function _utf8_decode(e) {
        var t = "";
        var n = 0;
        var r = 0,
            c1 = 0,
            c2 = 0,
            c3 = 0;
        while (n < e.length) {
          r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
            n++;
          } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode((r & 31) << 6 | c2 & 63);
            n += 2;
          } else {
            c2 = e.charCodeAt(n + 1);
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
            n += 3;
          }
        }
        return t;
      }
    };

    // Encode the String
    return Base64.encode(unescape(encodeURIComponent(str)));
  }
}

function base64_decode(str) {
  if (window.atob) // Internet Explorer 10 and above
    return decodeURIComponent(escape(window.atob(str)));else {
    // Cross-Browser Method (compressed)

    // Create Base64 Object
    var Base64 = {
      _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      encode: function encode(e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
          n = e.charCodeAt(f++);
          r = e.charCodeAt(f++);
          i = e.charCodeAt(f++);
          s = n >> 2;
          o = (n & 3) << 4 | r >> 4;
          u = (r & 15) << 2 | i >> 6;
          a = i & 63;
          if (isNaN(r)) {
            u = a = 64;
          } else if (isNaN(i)) {
            a = 64;
          }
          t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
        }
        return t;
      },
      decode: function decode(e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
          s = this._keyStr.indexOf(e.charAt(f++));
          o = this._keyStr.indexOf(e.charAt(f++));
          u = this._keyStr.indexOf(e.charAt(f++));
          a = this._keyStr.indexOf(e.charAt(f++));
          n = s << 2 | o >> 4;
          r = (o & 15) << 4 | u >> 2;
          i = (u & 3) << 6 | a;
          t = t + String.fromCharCode(n);
          if (u != 64) {
            t = t + String.fromCharCode(r);
          }
          if (a != 64) {
            t = t + String.fromCharCode(i);
          }
        }
        t = Base64._utf8_decode(t);
        return t;
      },
      _utf8_encode: function _utf8_encode(e) {
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
          } else if (r > 127 && r < 2048) {
            t += String.fromCharCode(r >> 6 | 192);
            t += String.fromCharCode(r & 63 | 128);
          } else {
            t += String.fromCharCode(r >> 12 | 224);
            t += String.fromCharCode(r >> 6 & 63 | 128);
            t += String.fromCharCode(r & 63 | 128);
          }
        }
        return t;
      },
      _utf8_decode: function _utf8_decode(e) {
        var t = "";
        var n = 0;
        var r = 0,
            c1 = 0,
            c2 = 0,
            c3 = 0;
        while (n < e.length) {
          r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
            n++;
          } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode((r & 31) << 6 | c2 & 63);
            n += 2;
          } else {
            c2 = e.charCodeAt(n + 1);
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
            n += 3;
          }
        }
        return t;
      }
    };

    // Encode the String
    return decodeURIComponent(escape(Base64.decode(str)));
  }
}

exports.default = {
  encode: base64_encode,
  decode: base64_decode
};
module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cookies.$inject = ["$location", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cookies;
function cookies($location, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('cookies');

  return {

    getAll: function getAll() {
      return $.cookie();
    },

    put: function put(key, value, expires, path, domain, secure) {
      LOGGER.log('put() key:' + key + ' expires:' + expires + ' path:' + path + ' domain:' + domain + ' secure:' + secure);

      if (!expires) {
        $.cookie(key, value, { path: path, domain: domain, secure: secure });
      } else {
        $.cookie(key, value, { expires: expires, path: path, domain: domain, secure: secure });
      }

      LOGGER.log('put() END');
      return $.cookie(key) ? true : false;
    },

    get: function get(key) {
      LOGGER.log('get(' + key + ')');

      var cook = $.cookie(key);
      return typeof cook !== 'undefined' ? cook : "";
    },

    remove: function remove(key, expires, path, domain, secure) {
      LOGGER.log('remove key:' + key + ' expires:' + expires + ' path:' + path + ' domain:' + domain + ' secure:' + secure);

      var val = null;
      if (expires != null) {
        val = $.removeCookie(key, { path: path, domain: domain, secure: secure });
      } else {
        val = $.removeCookie(key, { expires: expires, path: path, domain: domain, secure: secure });
      }

      LOGGER.log('remove() END - val:', val);

      return val;
    }

  };
};
module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hostGetter;
function hostGetter() {
  return location.host;
}
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceSafeApply.$inject = ["$rootScope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceSafeApply;
function iceSafeApply($rootScope) {
  'ngInject';

  return function (fn, $scope) {
    $scope = $scope || $rootScope;
    var phase = $scope.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
      if (fn) {
        $scope.$eval(fn);
      }
    } else {
      if (fn) {
        $scope.$apply(fn);
      } else {
        $scope.$apply();
      }
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceSubscribable.$inject = ["_", "$log"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.iceSubscribable = iceSubscribable;
function iceSubscribable(_, $log) {
    'ngInject';

    // shared private

    var instanceCount = -1;

    return SubscribableFactory;

    function SubscribableFactory(spec) {
        instanceCount++;
        spec = _.isObject(spec) ? spec : {};
        var log = $log.getInstance('iceSubscribable#' + (spec.name ? '[' + spec.name + ']' : instanceCount));
        log.debug('instance created.');

        var subscribers = {};

        return {
            subscribe: addSubscriber,
            publish: publish
        };

        function addSubscriber(topicName, fn) {
            var topic = getTopic(topicName);
            topic.push(fn);
            log.log('+ add mode listener for topic ' + topicName + ': ');

            return unsubscriber(topicName, fn);
        }

        function unsubscriber(topic, fn) {
            return function () {
                log.log('- removed mode listener for topic ' + topic + ': ', _.remove(getTopic(topic), function (subscr) {
                    return subscr === fn;
                }));
            };
        }

        function getTopic(name) {
            return subscribers[name] = subscribers[name] || [];
        }

        function publish(topicName, arg) {
            _.forEach(getTopic(topicName), function (fn) {
                try {
                    fn(arg);
                } catch (e) {
                    log.error(e);
                    try {
                        console.error(e);
                    } catch (e) {}
                }
            });
        }
    }
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _singleAndDoubleClick = __webpack_require__(53);

var _singleAndDoubleClick2 = _interopRequireDefault(_singleAndDoubleClick);

var _queryparam = __webpack_require__(1);

var _queryparam2 = _interopRequireDefault(_queryparam);

var _moment = __webpack_require__(80);

var _moment2 = _interopRequireDefault(_moment);

var _iceSubscribable = __webpack_require__(51);

var _iceSafeApply = __webpack_require__(50);

var _iceSafeApply2 = _interopRequireDefault(_iceSafeApply);

var _host = __webpack_require__(49);

var _host2 = _interopRequireDefault(_host);

var _cookies = __webpack_require__(48);

var _cookies2 = _interopRequireDefault(_cookies);

var _Base64StringUtil = __webpack_require__(47);

var _Base64StringUtil2 = _interopRequireDefault(_Base64StringUtil);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.utils.services', []).constant('_', _lodash2.default).constant('moment', _moment2.default).constant('queryParamGetter', _queryparam2.default).factory('singleAndDoubleClickHelper', _singleAndDoubleClick2.default).factory('iceSubscribable', _iceSubscribable.iceSubscribable).factory('iceSafeApply', _iceSafeApply2.default).factory('hostGetter', _host2.default).factory('cookies', _cookies2.default).factory('iceBase64StringUtil', _Base64StringUtil2.default).name;
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return create;

  function create(singleClickFn, doubleClickFn, delay) {
    var DELAY = delay || 700,
        clicks = 0,
        timer = null;

    return function handleClickEvent(e) {
      clicks++; //count clicks

      if (clicks === 1) {

        timer = setTimeout(function () {

          singleClickFn(e); //perform single-click action
          clicks = 0; //after action performed, reset counter
        }, DELAY);
      } else {

        clearTimeout(timer); //prevent single-click action
        doubleClickFn(e); //perform double-click action
        clicks = 0; //after action performed, reset counter
      }

      /*
       .on("dblclick", function (e) {
       e.preventDefault();  //cancel system double-click event
       });
       */
    };
  }
};

;
module.exports = exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncValidation;
function AsyncValidation($q) {

  function AsyncValidation() {
    this.validators = [];
    this.errors = {};

    this.checking = false;
    this._checkingPromise = null;
  }
  AsyncValidation.prototype.abort = function () {
    if (this.checking) {
      var abortRes;
      var promise = this._checkingPromise;

      if (angular.isFunction(promise.abort)) {
        abortRes = promise.abort();
      }
      this.checking = false;
      return abortRes;
    }
  };
  AsyncValidation.prototype.check = function () {
    this.reset();
    this.checking = true;

    var self = this;
    var aborted = false;

    self._checkingPromise = $q.when();
    this.validators.forEach(function (validator) {
      self._checkingPromise = self._checkingPromise.then(function (result) {
        console.log('[abort check]');
        if (aborted) {
          var d = $q.defer();
          d.reject('aborted');
          return d.promise;
        }
        return $q.when(result);
      });

      self._checkingPromise = self._checkingPromise.then(self._createValidation(validator));
    });

    self._checkingPromise = self._checkingPromise.then(function () {
      // tutte le promise sono state risolte
      self.checking = false;
      console.log('_checkingPromise errors keys:', _.keys(self.errors));
      return !_.keys(self.errors).length; // se nessuna chiave di errore è stata settata, tutto è ok!
    }, function (reason) {
      // qualcosa è andato storto
      self.checking = false;
      if (reason === 'aborted') {
        self.reset();
      }
      return false;
    });

    self._checkingPromise.abort = function () {
      aborted = true;
    };

    return this._checkingPromise;
  };
  AsyncValidation.prototype._createValidation = function (validator) {
    var self = this;
    var validatorName = validator.name;

    return function () {
      return validator.obj.validate.apply(self, arguments).then(function (satisfied) {
        console.log('validator.validate() name="' + validatorName + '" satisfied:', satisfied);
        if (satisfied === true) {
          delete self.errors[validatorName];
          console.log('validator.validate() name="' + validatorName + '" TRUE');
          return true;
        } else {
          self.errors[validatorName] = {
            result: satisfied
          };
          return false;
        }
      }, function (err) {
        self.errors[validatorName] = {
          error: err
        };
        return err;
      });
    };
  };
  AsyncValidation.prototype.reset = function () {
    this.abort();
    this.errors = {};
    this.checking = false;
  };
  AsyncValidation.prototype.addValidator = function (name, validator) {
    this.validators.push({
      name: name,
      obj: validator
    });
  };

  return AsyncValidation;
}
;
module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceBlockUi.$inject = ["$parse"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceBlockUi;
function iceBlockUi($parse) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    scope: false, // osserva e valuta @iceBlockUi, usa evenutalmente il selettore @blockTarget
    link: function link(scope, elem, attrs) {
      // WORKAROUND: explicit wrap with jquery because angularjs is not using jquery with this project
      // TODO find a solution for angularjs to use jqury instead of jqLite - PKD!
      elem = $(elem);

      var blocking = false;
      var options = {
        message: null,
        overlayCSS: { backgroundColor: '#fff' }
      };

      scope.$watch(function () {
        return $parse(attrs.iceBlockUi)(scope);
      }, function (newValue) {

        var targetElement = void 0;
        if (attrs.blockTarget) {
          targetElement = elem.find(attrs.blockTarget);
        }
        if (!targetElement) {
          targetElement = elem;
        }

        if (newValue) {
          blocking = true;
          targetElement.block(options);
        } else {
          blocking = false;
          targetElement.unblock();
        }
      });

      scope.$on('$destroy', function () {
        if (blocking) {
          elem.unblock();
        }
      });
    }
  };
};
module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bootstrapSwitch;
/**
 * Binding della libreria bootstrap-switch
 *
 * @example
 * <input type="checkbox" ng-model="mymodel.mystate" bootstrap-switch />
 *
 * @see https://github.com/nostalgiaz/bootstrap-switch
 */
function bootstrapSwitch() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {

      element.bootstrapSwitch({});

      element.on('switchChange.bootstrapSwitch', function (event, state) {
        if (ngModel) {
          scope.$apply(function () {
            ngModel.$setViewValue(state);
          });
        }
      });

      scope.$watch(attrs.ngModel, function (newValue) {
        element.bootstrapSwitch('state', !!newValue, true);
      });

      scope.$on('$destroy', function () {
        element.bootstrapSwitch('destroy');
      });
    }
  };
}
;
module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A directive that allows to interrupt the chain of events that end up changing state.
 * For convenience and other uses also prevents the execution of ng-click on the same element.
 * @see http://stackoverflow.com/questions/25600071/how-to-achieve-that-ui-sref-be-conditionally-executed
 */

eatClickIf.$inject = ["$parse", "$rootScope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = eatClickIf;
function eatClickIf($parse, $rootScope) {
  'ngInject';

  return {
    // this ensure eatClickIf be compiled before ngClick
    priority: 100,
    restrict: 'A',
    compile: function compile($element, attr) {
      var fn = $parse(attr.eatClickIf);
      return {
        pre: function link(scope, element) {
          var eventName = 'click';
          element.on(eventName, function (event) {
            var callback = function callback() {
              if (fn(scope, { $event: event })) {
                // prevents ng-click to be executed
                event.stopImmediatePropagation();
                // prevents href
                event.preventDefault();
                return false;
              }
            };
            if ($rootScope.$$phase) {
              scope.$evalAsync(callback);
            } else {
              scope.$apply(callback);
            }
          });
        },
        post: function post() {}
      };
    }
  };
};
module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * <input ice-auto-focus >
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceAutoFocus;
function iceAutoFocus($timeout, $log) {
  var logger = $log.getInstance('iceAutoFocus');

  return {
    restrict: 'A',
    link: link
  };

  function link(scope, element, attrs) {

    var timeout = $timeout(function () {
      try {
        element.focus();
      } catch (e) {
        logger.error('Error focusing element:', element, e);
      }
      element.focus();
    }, 400);

    scope.$on('$destroy', function () {
      $timeout.cancel(timeout);
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceNoKeysHistoryNav.$inject = ["$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceNoKeysHistoryNav;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// commented with "replaced in path": import angular from 'angular';

/**
 * Previene la navigazione della pagina premendo il tasto BACKSPACE (keyCode 8)
 * @see http://stackoverflow.com/questions/1495219/how-can-i-prevent-the-backspace-key-from-navigating-back?lq=1
 */
function iceNoKeysHistoryNav($log) {
  'ngInject';

  var LOGGER = $log.getInstance('iceNoKeysHistoryNav');

  return {
    restrict: 'A',
    link: linkFn
  };

  function linkFn() {
    'ngInject';

    LOGGER.log('linking');

    angular.element(document).unbind('keydown').bind('keydown', preventFn);

    var blockingInputElementTypes = ['TEXT', 'PASSWORD', 'FILE', 'SEARCH', 'EMAIL', 'NUMBER', 'DATE'];
    var isBlockingInputType = _lodash2.default.memoize(function isBlockingInputType(type) {
      return _lodash2.default.find(blockingInputElementTypes, function (blockType) {
        return blockType == type;
      });
    });

    function preventFn(event) {
      var doPrevent = false;
      if (event.keyCode === 8) {
        var d = event.srcElement || event.target;

        if (d.tagName.toUpperCase() === 'INPUT' && isBlockingInputType(d.type.toUpperCase()) || d.tagName.toUpperCase() === 'TEXTAREA') {
          doPrevent = d.readOnly || d.disabled;
        } else {
          doPrevent = true;
        }
      }

      if (doPrevent) {
        LOGGER.log('iceNoKeysHistoryNav: prevented key event', event.keyCode);
        event.preventDefault();
      }
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceBindHtmlCompile.$inject = ["$compile"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceBindHtmlCompile;
/**
 * The ice-bind-html-compile directive allows for HTML containing directives to be compiled.
 *
 * @source copy/pasted from https://github.com/incuna/angular-bind-html-compile
 */
function iceBindHtmlCompile($compile) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.$watch(function () {
        return scope.$eval(attrs.iceBindHtmlCompile);
      }, function (value) {
        // In case value is a TrustedValueHolderType, sometimes it
        // needs to be explicitly called into a string in order to
        // get the HTML string.
        element.html(value && value.toString());
        // If scope is provided use it, otherwise use parent scope
        var compileScope = scope;
        if (attrs.bindHtmlScope) {
          compileScope = scope.$eval(attrs.bindHtmlScope);
        }
        $compile(element.contents())(compileScope);
      });
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceNoParentScroll;
/**
* Direttiva che previene la propagazione dello scroll ai contenitori esterni (padri)
* quando l'elemento attuale in fase di scroll raggiunge gli estremi top o bottom
*
* @example
* <div ice-no-parent-scroll style="overflow-y: scroll"></div>
*
* Il codice originario proviene da:
* @see http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element
*/
function iceNoParentScroll($timeout) {

  var attachFn = function attachFn(element) {
    return element.on('DOMMouseScroll mousewheel', function (ev) {
      var $this = $(this),
          scrollTop = this.scrollTop,
          scrollHeight = this.scrollHeight,
          height = $this.height(),
          delta = ev.originalEvent.wheelDelta,
          up = delta > 0;

      var prevent = function prevent() {
        ev.stopPropagation();
        ev.preventDefault();
        ev.returnValue = false;
        return false;
      };

      if (!up && -delta > scrollHeight - height - scrollTop) {
        // Scrolling down, but this will take us past the bottom.
        $this.scrollTop(scrollHeight);
        return prevent();
      } else if (up && delta > scrollTop) {
        // Scrolling up, but this will take us past the top.
        $this.scrollTop(0);
        return prevent();
      }
    });
  };

  var detachFn = function detachFn(element) {
    element.off('DOMMouseScroll mousewheel');
  };

  return {
    restrict: 'A',
    link: function link(scope, element) {

      //$timeout(function () {
      attachFn(element);
      //},1000);

      scope.$on('$destroy', function () {
        detachFn(element);
      });
    }
  };
}
;
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = includeReplace;
function includeReplace() {
  return {
    require: 'ngInclude',
    restrict: 'A',
    link: function link(scope, el) {
      el.replaceWith(el.children());
    }
  };
};
module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AsyncValidation = __webpack_require__(54);

var _AsyncValidation2 = _interopRequireDefault(_AsyncValidation);

var _blockUI = __webpack_require__(55);

var _blockUI2 = _interopRequireDefault(_blockUI);

var _bootstrapSwitch = __webpack_require__(56);

var _bootstrapSwitch2 = _interopRequireDefault(_bootstrapSwitch);

var _eatClickIf = __webpack_require__(57);

var _eatClickIf2 = _interopRequireDefault(_eatClickIf);

var _iceAutofocus = __webpack_require__(58);

var _iceAutofocus2 = _interopRequireDefault(_iceAutofocus);

var _iceNoKeysHistoryNav = __webpack_require__(59);

var _iceNoKeysHistoryNav2 = _interopRequireDefault(_iceNoKeysHistoryNav);

var _iceNoParentScroll = __webpack_require__(61);

var _iceNoParentScroll2 = _interopRequireDefault(_iceNoParentScroll);

var _includeReplace = __webpack_require__(62);

var _includeReplace2 = _interopRequireDefault(_includeReplace);

var _iceBindHtmlCompile = __webpack_require__(60);

var _iceBindHtmlCompile2 = _interopRequireDefault(_iceBindHtmlCompile);

var _now = __webpack_require__(64);

var _now2 = _interopRequireDefault(_now);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('infocert.js.angular.utils.ui', []).factory('AsyncValidation', _AsyncValidation2.default).directive('iceBlockUi', _blockUI2.default).directive('bootstrapSwitch', _bootstrapSwitch2.default).directive('eatClickIf', _eatClickIf2.default).directive('iceAutoFocus', _iceAutofocus2.default).directive('iceNoKeysHistoryNav', _iceNoKeysHistoryNav2.default).directive('iceNoParentScroll', _iceNoParentScroll2.default).directive('includeReplace', _includeReplace2.default).directive('iceBindHtmlCompile', _iceBindHtmlCompile2.default).directive('now', _now2.default).name;
module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = now;
/**
 * direttiva di test per verificare quando vengono istanziati i controller
 */
function now() {
  var count = 0;
  function link(scope, element) {
    //element.text((count++) +' '+ moment().format('HH:mm:ss.SSS'));
  }

  return {
    link: link
  };
}
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceXSRFProtection = iceXSRFProtection;

/**
 * @author Claudio Germani
 */

function iceXSRFProtection() {

  var XSRF_RESPONSE_HEADER_NAME = 'X-XSRF-TOKEN',
      XSRF_REQUEST_HEADER_NAME = 'X-XSRF-TOKEN',
      XSRF_REQUEST_FORMPARAM_NAME = '_xsrf',
      DEBUG = false,
      CURRENT_TOKEN = null;

  // public provider methods
  this.setRequestHeaderName = setRequestHeaderName;
  this.setRequestFormParamName = setRequestFormParamName;
  this.setResponseHeaderName = setResponseHeaderName;
  this.setDebugStatus = setDebugStatus;

  this.$get = function () {
    // public service methods
    return {
      isDebugEnabled: isDebugEnabled,

      getRequestHeaderName: getRequestHeaderName,
      getRequestFormParamName: getRequestFormParamName,
      getResponseHeaderName: getResponseHeaderName,

      setToken: setToken,
      getToken: getToken
    };
  };

  // --------------------------------------------
  // provider methods impl

  function setDebugStatus(enable) {
    DEBUG = !!enable;
    return this;
  }

  function setRequestHeaderName(name) {
    XSRF_REQUEST_HEADER_NAME = name;
    return this;
  }

  function setRequestFormParamName(name) {
    XSRF_REQUEST_FORMPARAM_NAME = name;
    return this;
  }

  function setResponseHeaderName(name) {
    XSRF_RESPONSE_HEADER_NAME = name;
    return this;
  }

  // --------------------------------------------
  // service methods impl


  function isDebugEnabled() {
    return DEBUG;
  }

  function getRequestHeaderName() {
    return XSRF_REQUEST_HEADER_NAME;
  }

  function getRequestFormParamName() {
    return XSRF_REQUEST_FORMPARAM_NAME;
  }

  function getResponseHeaderName() {
    return XSRF_RESPONSE_HEADER_NAME;
  }

  function setToken(token) {
    CURRENT_TOKEN = token;
  }
  function getToken() {
    return CURRENT_TOKEN;
  }
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


iceXSRFTokenHttpInterceptor.$inject = ["iceXSRFProtection", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iceXSRFTokenHttpInterceptor = iceXSRFTokenHttpInterceptor;

/**
 * @author Claudio Germani
 */

function iceXSRFTokenHttpInterceptor(iceXSRFProtection, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('iceXSRFTokenHttpInterceptor');
  var XSRF_RESPONSE_HEADER_NAME = iceXSRFProtection.getResponseHeaderName();
  var XSRF_REQUEST_HEADER_NAME = iceXSRFProtection.getRequestHeaderName();
  var DEBUG = iceXSRFProtection.isDebugEnabled();

  return {
    'request': function request(config) {
      var token = iceXSRFProtection.getToken() || '';
      if (!token) {
        if (DEBUG) LOGGER.debug('current token is empty..');
      }
      //if (token) {
      if (DEBUG) LOGGER.debug('pushing header "' + XSRF_REQUEST_HEADER_NAME + '" with token value "' + token + '"');
      config.headers[XSRF_REQUEST_HEADER_NAME] = token;
      //}

      return config;
    },
    'response': function response(_response) {
      var token = _response.headers(XSRF_RESPONSE_HEADER_NAME);
      if (token) {
        if (DEBUG) LOGGER.debug('updating token with value ' + token + ' (from header: "' + XSRF_RESPONSE_HEADER_NAME + '")');
        iceXSRFProtection.setToken(token);
      } else {
        if (DEBUG) LOGGER.debug('missing token from response (header: "' + XSRF_RESPONSE_HEADER_NAME + '"). SKIP token update.');
      }

      return _response;
    }
  };
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iceXSRFProtection = __webpack_require__(65);

var _iceXSRFTokenHttpInterceptor = __webpack_require__(66);

/**
 * @author Claudio Germani
 */

exports.default = angular.module('infocert.js.angular.xsrf', [
  // no external dependencies required
]).provider('iceXSRFProtection', _iceXSRFProtection.iceXSRFProtection).factory('iceXSRFTokenHttpInterceptor', _iceXSRFTokenHttpInterceptor.iceXSRFTokenHttpInterceptor).name;
module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$qConfig.$inject = ["$qProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.$qConfig = $qConfig;
function $qConfig($qProvider) {
    'ngInject';

    // @see https://docs.angularjs.org/api/ng/provider/$qProvider

    $qProvider.errorOnUnhandledRejections(false);
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


commonStatesConfig.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonStatesConfig = commonStatesConfig;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function commonStatesConfig($stateProvider) {
    'ngInject';

    var rootViewName = ''; // old was: layout-container
    var targetStateNames = {
        FECON_PRECONDITION_FAILED: 'FECON_PRECONDITION_FAILED', // generic
        FECON_CUSTOMIZATION_ERROR: 'FECON_CUSTOMIZATION_ERROR',
        STATE_404: 'STATE_404'
    };

    $stateProvider.state(targetStateNames.STATE_404, {
        views: _defineProperty({}, rootViewName, {
            template: '' + '<div class="container-fluid">' + '   <div class="row">' + '       <div class="col-xs-12 text-center" style="margin-top: 40px">' + '           <div style="font-size: 32px; color: #333; margin-bottom: 6px;">404 &nbsp; :(</div>' + '           <div style="display: inline-block; border-left: 12px solid #e7e7e7; padding-left: 12px; text-align: left;">' + '               La risorsa richiesta non &egrave; stata trovata.' + '               <br>Si prega di verificare la richiesta o riprovare successivamente.' + '           </div>' + '       </div>' + '   </div>' + '</div>'
        })
    });

    $stateProvider.state(targetStateNames.FECON_PRECONDITION_FAILED, {
        views: _defineProperty({}, rootViewName, {
            template: '' + '<div class="container-fluid">' + '   <div class="row">' + '       <div class="col-xs-12 text-center" style="margin-top: 40px">' + '           <div style="font-size: 32px; color: #333; margin-bottom: 6px;">:(</div>' + '           <div style="display: inline-block; border-left: 2px solid #666; padding-left: 6px; text-align: left;">' + '               Si &egrave; verificato un errore nell\'inizializzazione dell\'applicazione.' + '               <br>Si prega di verificare la richiesta o riprovare successivamente.' + '           </div>' + '       </div>' + '   </div>' + '</div>'
        })
    });

    $stateProvider.state(targetStateNames.FECON_CUSTOMIZATION_ERROR, {
        views: _defineProperty({}, rootViewName, {
            template: '' + '<div class="container-fluid">' + '   <div class="row">' + '       <div class="col-xs-12 text-center" style="margin-top: 40px">' + '           <div style="font-size: 32px; color: #333; margin-bottom: 6px;">:(</div>' + '           <div style="display: inline-block; border-left: 2px solid #666; padding-left: 6px; text-align: left;">' + '               Un componente grafico richiesto non &egrave; al momento disponibile.' + '               <br>Si prega di verificare la richiesta o riprovare successivamente.' + '           </div>' + '       </div>' + '   </div>' + '</div>'
        })
    });
}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productConfiguratorConfig.$inject = ["iceApplicationConfiguratorProvider", "queryParamGetter"];
productConfiguratorDebug_runFn.$inject = ["iceApplicationConfigurator", "queryParamGetter"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productConfiguratorConfig = productConfiguratorConfig;
exports.productConfiguratorDebug_runFn = productConfiguratorDebug_runFn;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function productConfiguratorConfig(iceApplicationConfiguratorProvider, queryParamGetter) {
  'ngInject';

  var configFolder = 'conf/';
  var configFileName = 'config.json';

  var requiredCustomConfigFileName = _lodash2.default.trim(queryParamGetter('iceConfigName', true));
  if (requiredCustomConfigFileName) {
    console && console.log('[FeCon] - Required custom configuration "' + requiredCustomConfigFileName + "'");
    configFileName = requiredCustomConfigFileName;
  }
  iceApplicationConfiguratorProvider.setConfigResourceUrl(configFolder + configFileName);

  // define configurators
  var configurators = ['iceCustomizationConfigurator', 'icePreferencesConfigurator'];
  iceApplicationConfiguratorProvider.setConfigurators(configurators);

  // enable configuration process on run() phase
  iceApplicationConfiguratorProvider.setAutoLoadEnabled(true);
}

function productConfiguratorDebug_runFn(iceApplicationConfigurator, queryParamGetter) {
  'ngInject';

  if (_lodash2.default.trim(queryParamGetter('iceDebug', true))) {
    window.iceApplicationConfigurator = iceApplicationConfigurator;
  }
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



productCustomizerConfig.$inject = ["uiCustomizerConfigProvider"];
productPreferencesConfig.$inject = ["iceApplicationPreferencesProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productCustomizerConfig = productCustomizerConfig;
exports.productPreferencesConfig = productPreferencesConfig;


function productCustomizerConfig(uiCustomizerConfigProvider) {
  'ngInject';

  var config_default = {
    configResourceUrl: 'ui-customization/',
    customizers: ['icePreferencesCustomizer', 'iceIconsCustomizer', 'iceStylesheetCustomizer'],
    isOptional: true
  };

  uiCustomizerConfigProvider.setZoneConfig('default', config_default);
}

function productPreferencesConfig(iceApplicationPreferencesProvider) {
  'ngInject';

  var defaultPreferences = {
    "k": "v"
  };

  //iceApplicationPreferencesProvider.setPreferences(defaultPreferences, false);
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$translateProvider_debugCongifFn.$inject = ["$translateProvider"];
i18nMomentSynchronizer_runFn.$inject = ["$translate", "$rootScope", "moment", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$translateProvider_debugCongifFn = $translateProvider_debugCongifFn;
exports.i18nMomentSynchronizer_runFn = i18nMomentSynchronizer_runFn;

var _queryparam = __webpack_require__(1);

var _queryparam2 = _interopRequireDefault(_queryparam);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function $translateProvider_debugCongifFn($translateProvider) {
  'ngInject';

  if ((0, _queryparam2.default)('iceDebug')) {
    window.$translateProvider = $translateProvider;
  }
}

function i18nMomentSynchronizer_runFn($translate, $rootScope, moment, $log) {
  'ngInject';

  var logger = $log.getInstance('i18nMomentSynchronizer');

  // sink on first run..
  updateMomentLocale();

  // listen $translate to stay in sink..
  $rootScope.$on('$translateChangeSuccess', localeChanged);

  function localeChanged() {
    logger.info('Locale changed. Current: ', $translate.use());
    updateMomentLocale();
  }

  // synk moment
  function updateMomentLocale() {
    moment.locale($translate.use());
  }
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


uiRouterConfig.$inject = ["$urlServiceProvider"];
routerErrorHandler_runFn.$inject = ["$state", "$log", "queryParamGetter"];
routerDebug_runFn.$inject = ["$trace", "$state", "queryParamGetter", "$log"];
routerDismissModalsOnTransitions_runFn.$inject = ["$transitions", "$uibModalStack", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiRouterConfig = uiRouterConfig;
exports.routerErrorHandler_runFn = routerErrorHandler_runFn;
exports.routerDebug_runFn = routerDebug_runFn;
exports.routerDismissModalsOnTransitions_runFn = routerDismissModalsOnTransitions_runFn;
function uiRouterConfig($urlServiceProvider) {
  'ngInject';

  /**
   * @see https://ui-router.github.io/ng1/docs/1.0.0/interfaces/url.urlrulesapi.html
   *
   * UrlRulesApi.initial(handler: string | UrlRuleHandlerFn | TargetState | TargetStateDef, options?: object): void
   * Defines the initial state, path, or behavior to use when the app starts.
   *
   * This rule is triggered the first time the URL is checked (when the app initially loads).
   * The rule is triggered only when the url matches either "" or "/".
   * Note: The rule is intended to be used when the root of the application is directly linked to.
   * When the URL is not "" or "/" and doesn't match other rules, the otherwise rule is triggered.
   * This allows 404-like behavior when an unknown URL is deep-linked.
   */
  //$urlServiceProvider.rules.initial({ state: defaultState });

  /**
   * @see https://ui-router.github.io/ng1/docs/1.0.0/interfaces/url.urlrulesapi.html
   *
   * UrlRulesApi.otherwise(handler: string | UrlRuleHandlerFn | TargetState | TargetStateDef): void
   * Defines the state, url, or behavior to use when no other rule matches the URL.
   *
   * This rule is matched when no other rule matches. It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
   */

  $urlServiceProvider.rules.otherwise({ state: 'STATE_404' });
}

function routerErrorHandler_runFn($state, $log, queryParamGetter) {
  'ngInject';

  var LOGGER = $log.getInstance('routerErrorHandler');

  var routingErrors = [];

  if (queryParamGetter('iceDebug')) {
    window.feconRoutingErrors = routingErrors;
  }

  $state.defaultErrorHandler(function (error) {
    routingErrors.push(error);
    LOGGER.error('Error id:' + error.$id + ' type:' + error.type + ' - message:' + error.message);
    LOGGER.error(error.detail);
  });

  // NOTA: questo metodo viene usato per fare LazyLoad degli stati.. se lo uso solo per loggare gli errori perdo il LazyLoad .. gestire quando servità
  $state.onInvalid(function (to, from, injector) {
    routingErrors.push(new Error('Invalid target state transition to: ' + to.name()));
    LOGGER.error('Invalid target state: ' + to.name());
    LOGGER.error('Redirecting to STATE_404 ..');
    return $state.target('STATE_404');
  });
}

function routerDebug_runFn($trace, $state, queryParamGetter, $log) {
  'ngInject';

  if (queryParamGetter('iceDebug')) {
    window.$state = $state;
  }

  var LOGGER = $log.getInstance('routerDebug');

  if (queryParamGetter('iceLog')) {
    $trace.enable('TRANSITION');
    LOGGER.info('Router Transitions debug enabled.');
  }
}

function routerDismissModalsOnTransitions_runFn($transitions, $uibModalStack, $log) {
  'ngInject';

  var LOGGER = $log.getInstance('routerDismissModalsOnTransitions');

  $transitions.onFinish({}, function (trans) {
    trans.promise.finally(handleChange);
  });

  function handleChange() {
    LOGGER.log('Transition complete, dismissing all Modal instances..');
    $uibModalStack.dismissAll('__DISMISSED_BY_STATE_CHANGE');
  }
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return (/*queryParamGetter('iceDev') &&*/!!(0, _queryparam2.default)('iceFakeApi')
    );
};

var _queryparam = __webpack_require__(1);

var _queryparam2 = _interopRequireDefault(_queryparam);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _$q = __webpack_require__(68);

var _commonStates = __webpack_require__(69);

var _i18n = __webpack_require__(72);

var _configurator = __webpack_require__(70);

var _customization = __webpack_require__(71);

var _router = __webpack_require__(73);

var _useFakeApi = __webpack_require__(74);

var _useFakeApi2 = _interopRequireDefault(_useFakeApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translateModule = 'pascalprecht.translate';

exports.default = angular.module('infocert.js.angular-bundle.default-configurations', [translateModule]).value('useFakeApi', (0, _useFakeApi2.default)())

// $q
.config(_$q.$qConfig)

// common states (preconditions error)
.config(_commonStates.commonStatesConfig)

// i18n
.config(_i18n.$translateProvider_debugCongifFn).run(_i18n.i18nMomentSynchronizer_runFn)

// application configurator
.config(_configurator.productConfiguratorConfig).run(_configurator.productConfiguratorDebug_runFn)

// application customizations, initial preferences
.config(_customization.productCustomizerConfig).config(_customization.productPreferencesConfig)

// router
.config(_router.uiRouterConfig).run(_router.routerErrorHandler_runFn).run(_router.routerDebug_runFn).run(_router.routerDismissModalsOnTransitions_runFn).name;
module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_78__;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_79__;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_80__;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_81__;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
});
//# sourceMappingURL=fecon-client-bundle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@infocert/fecon-client-bundle/dist/@infocert/fecon-client-bundle.js
// module id = 233
// module chunks = 0